webpackJsonp([8],{

/***/ "+H+X":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Header__ = __webpack_require__("+RsY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Nav__ = __webpack_require__("Czq0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Footer__ = __webpack_require__("RVJ0");






var DtIndex = function DtIndex() {
    return __webpack_require__.e/* import() */(3).then(__webpack_require__.bind(null, "+mLf"));
};
var DtTeam = function DtTeam() {
    return __webpack_require__.e/* import() */(2).then(__webpack_require__.bind(null, "GrBa"));
};
var DtEvents = function DtEvents() {
    return __webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, "SCfo"));
};
var DtPublications = function DtPublications() {
    return __webpack_require__.e/* import() */(1).then(__webpack_require__.bind(null, "vn7X"));
};
var DtContacts = function DtContacts() {
    return __webpack_require__.e/* import() */(5).then(__webpack_require__.bind(null, "9bGI"));
};
var DtTmp = function DtTmp() {
    return __webpack_require__.e/* import() */(4).then(__webpack_require__.bind(null, "QUpN"));
};

/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'dt',
    head: {
        title: function title() {
            return {
                inner: this.isENG ? this.title : this.title_rus,
                separator: ' ',
                complement: ' '
            };
        },
        meta: function meta() {
            return [{
                name: 'keywords',
                content: this.isENG ? this.keywords : this.keywords_rus
            }, {
                name: 'description',
                content: this.isENG ? this.description : this.description_rus
            }];
        },

        link: [{
            rel: 'icon',
            href: 'static/pictures/dt/logo/favicon.png',
            sizes: '16x16',
            type: 'image/png'
        }]
    },
    components: {
        'dt-header': __WEBPACK_IMPORTED_MODULE_0__components_Header__["a" /* default */],
        'dt-nav': __WEBPACK_IMPORTED_MODULE_1__components_Nav__["a" /* default */],
        'dt-footer': __WEBPACK_IMPORTED_MODULE_2__components_Footer__["a" /* default */]
    },
    routes: [{ name: 'dt-page-index',
        path: '',
        title: 'Home',
        title_rus: 'Главная',
        description: 'Skoltech | Laboratory of Prof. Andrzej Cichocki | Tensor networks and deep learning for applications in data mining',
        description_rus: 'Сколтех | Лаборатория Тензорные сети и глубинное обучение для интеллектуального анализа данных под руководством доктора Анджея Чихоцкого',
        keywords: 'Tensor networks, deep learning, neural networks, megagrant, skoltech, Andrzej Cichocki, Ivan Oseledets,  Victor Lempitsky,  Dmitry Vetrov',
        keywords_rus: 'Тензорные сети, глубинное обучение, глубокое обучение, нейронные сети, мегагрант, Сколтех, Анджей Чихоцкий, Иван Оселедец, Виктор Лемпицкий, Дмитрий Ветров',
        isInNav: true,
        component: DtIndex
    }, { name: 'dt-page-team',
        path: 'team/:id?',
        title: 'Team',
        title_rus: 'Команда',
        description: 'Skoltech | Laboratory of Prof. Andrzej Cichocki | Tensor networks and deep learning for applications in data mining | Team',
        description_rus: 'Сколтех | Лаборатория Тензорные сети и глубинное обучение для интеллектуального анализа данных под руководством доктора Анджея Чихоцкого | Команда',
        keywords: 'Tensor networks, deep learning, neural networks, megagrant, skoltech, Andrzej Cichocki, Ivan Oseledets,  Victor Lempitsky,  Dmitry Vetrov',
        keywords_rus: 'Тензорные сети, глубинное обучение, глубокое обучение, нейронные сети, мегагрант, Сколтех, Анджей Чихоцкий, Иван Оселедец, Виктор Лемпицкий, Дмитрий Ветров',
        isInNav: true,
        props: true,
        component: DtTeam
    }, { name: 'dt-page-events',
        path: 'events/:id?',
        title: 'Events',
        title_rus: 'События',
        description: 'Skoltech | Laboratory of Prof. Andrzej Cichocki | Tensor networks and deep learning for applications in data mining | Events',
        description_rus: 'Сколтех | Лаборатория Тензорные сети и глубинное обучение для интеллектуального анализа данных под руководством доктора Анджея Чихоцкого | События',
        keywords: 'Tensor networks, deep learning, neural networks, megagrant, skoltech, Andrzej Cichocki, Ivan Oseledets,  Victor Lempitsky,  Dmitry Vetrov, megagrant, seminar, conference, staff',
        keywords_rus: 'Тензорные сети, глубинное обучение, глубокое обучение, нейронные сети, мегагрант, Сколтех, Анджей Чихоцкий, Иван Оселедец, Виктор Лемпицкий, Дмитрий Ветров, мегагрант, семинары, штат лаборатории',
        isInNav: true,
        props: true,
        component: DtEvents
    }, { name: 'dt-page-publications',
        path: 'publications',
        title: 'Publications',
        title_rus: 'Публикации',
        description: 'Skoltech | Laboratory of Prof. Andrzej Cichocki | Tensor networks and deep learning for applications in data mining | Publications',
        description_rus: 'Сколтех | Лаборатория Тензорные сети и глубинное обучение для интеллектуального анализа данных под руководством доктора Анджея Чихоцкого | Публикации',
        keywords: 'Тензорные сети, глубинное обучение, глубокое обучение, нейронные сети, мегагрант, Сколтех, Анджей Чихоцкий, Иван Оселедец, Виктор Лемпицкий, Дмитрий Ветров, публикации, WoS, Scopus',
        keywords_rus: 'Тензорные сети, глубинное обучение, глубокое обучение, нейронные сети, мегагрант, Сколтех, Анджей Чихоцкий, Иван Оселедец, Виктор Лемпицкий, Дмитрий Ветров, мегагрант, семинары, штат лаборатории',
        isInNav: true,
        component: DtPublications
    }, { name: 'dt-page-contacts',
        path: 'contacts',
        title: 'Contacts',
        title_rus: 'Контакты',
        description: 'Skoltech | Laboratory of Prof. Andrzej Cichocki | Tensor networks and deep learning for applications in data mining | Contacts',
        description_rus: 'Сколтех | Лаборатория Тензорные сети и глубинное обучение для интеллектуального анализа данных под руководством доктора Анджея Чихоцкого | Контактная информация',
        keywords: 'Tensor networks, deep learning, neural networks, megagrant, skoltech, skolkovo, Andrzej Cichocki, Ivan Oseledets,  Victor Lempitsky,  Dmitry Vetrov',
        keywords_rus: 'Тензорные сети, глубинное обучение, глубокое обучение, нейронные сети, мегагрант, Сколтех, деревня Сколково, Анджей Чихоцкий, Иван Оселедец, Виктор Лемпицкий, Дмитрий Ветров',
        isInNav: true,
        component: DtContacts
    }, { name: 'dt-page-tmp',
        path: 'tmp',
        component: DtTmp
    }],
    data: function data() {
        return {
            title: 'Deeptensor',
            title_rus: 'Deeptensor',
            description: 'Deeptensor',
            description_rus: 'Deeptensor',
            keywords: 'Deeptensor',
            keywords_rus: 'Deeptensor',
            routeDir: 'left'
        };
    },

    computed: {
        pages: function pages() {
            var _this = this;

            return this.$options.routes.filter(function (p) {
                return p.isInNav;
            }).map(function (p) {
                return {
                    name: p.name,
                    title: _this.isENG ? p.title : p.title_rus,
                    params: p.params
                };
            });
        }
    },
    created: function created() {
        var _this2 = this;

        var page = this.$options.routes.find(function (p) {
            return p.name == _this2.$route.name;
        });
        this.headUpdate(page);
    },
    beforeRouteUpdate: function beforeRouteUpdate(to, from, next) {
        var i1 = this.$options.routes.findIndex(function (p) {
            return p.name == from.name;
        });
        var i2 = this.$options.routes.findIndex(function (p) {
            return p.name == to.name;
        });
        var page = this.$options.routes.find(function (p) {
            return p.name == to.name;
        });
        if (i1 > i2) this.routeDir = 'right';
        if (i1 == i2) this.routeDir = 'down';
        if (i1 < i2) this.routeDir = 'left';
        this.headUpdate(page);
        next();
    },

    methods: {
        headUpdate: function headUpdate(page) {
            var _arr = ['title', 'description', 'keywords'];

            for (var _i = 0; _i < _arr.length; _i++) {
                var prop = _arr[_i];var _arr2 = ['', '_rus'];

                for (var _i2 = 0; _i2 < _arr2.length; _i2++) {
                    var lang = _arr2[_i2];
                    this[prop + lang] = page[prop + lang];
                }
            }this.$emit('updateHead');
        }
    }
});

/***/ }),

/***/ "+M4T":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/logo_skoltech_rus.7f818c8.png";

/***/ }),

/***/ "+RsY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Header_vue__ = __webpack_require__("GXKz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_775cd8b5_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_Header_vue__ = __webpack_require__("fyb3");
function injectStyle (ssrContext) {
  __webpack_require__("v/J1")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Header_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_775cd8b5_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_Header_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "/3jw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__("Zrlr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__("wxAW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__GeomAxis_js__ = __webpack_require__("foHI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__animation_js__ = __webpack_require__("ycBr");





/* Geom : keep and modify position and length of 2D object
 * Only objects obj.x and obj.y are modified.
 * See GeomAxis class for more details.
*/

var Geom = function () {
  function Geom(obj) {
    var ext = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var lim = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Geom);

    this.x = new __WEBPACK_IMPORTED_MODULE_2__GeomAxis_js__["a" /* default */](obj.x, ext.x, lim.x);
    this.y = new __WEBPACK_IMPORTED_MODULE_2__GeomAxis_js__["a" /* default */](obj.y, ext.y, lim.y);
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(Geom, [{
    key: 'check',
    value: function check() {
      var res = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

      return this.y.check(this.x.check(res));
    }
  }, {
    key: 'move',
    value: function move() {
      var dpos = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : { x: 0, y: 0 };

      return {
        x: this.x.move(dpos.x),
        y: this.y.move(dpos.y)
      };
    }
  }, {
    key: 'moveTo',
    value: function moveTo() {
      var pos = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : { x: null, y: null };

      return {
        x: this.x.moveTo(pos.x),
        y: this.y.moveTo(pos.y)
      };
    }
  }, {
    key: 'resize',
    value: function resize() {
      var dlen = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : { x: 0, y: 0 };
      var dir = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : { x: 1, y: 1 };

      return {
        x: this.x.resize(dlen.x, dir.x),
        y: this.y.resize(dlen.y, dir.y)
      };
    }
  }, {
    key: 'resizeTo',
    value: function resizeTo() {
      var len = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : { x: null, y: null };
      var dir = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : { x: 1, y: 1 };

      return {
        x: this.x.resizeTo(len.x, dir.x),
        y: this.y.resizeTo(len.y, dir.y)
      };
    }
  }, {
    key: 'increase',
    value: function increase() {
      var delt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : { x: 1, y: 1 };

      var resx = this.x.increase(delt.x);
      var resy = this.y.increase(delt.y);
      return resx || resy;
    }
  }, {
    key: 'maximize',
    value: function maximize() {
      var _this = this;

      var delt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : { x: 1, y: 1 };

      Object(__WEBPACK_IMPORTED_MODULE_3__animation_js__["a" /* default */])(function () {
        return _this.increase({ x: delt.x, y: delt.y });
      });
    }
  }, {
    key: 'minimize',
    value: function minimize() {
      var _this2 = this;

      var delt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : { x: 1, y: 1 };

      Object(__WEBPACK_IMPORTED_MODULE_3__animation_js__["a" /* default */])(function () {
        return _this2.increase({ x: -delt.x, y: -delt.y });
      });
    }
  }, {
    key: 'getPosDelt',
    value: function getPosDelt() {
      return { x: this.x.getPosDelt(), y: this.y.getPosDelt() };
    }
  }, {
    key: 'getLenDelt',
    value: function getLenDelt() {
      return { x: this.x.getLenDelt(), y: this.y.getLenDelt() };
    }
  }]);

  return Geom;
}();

/* harmony default export */ __webpack_exports__["a"] = (Geom);

/***/ }),

/***/ "/zAt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DemoBuilder_vue__ = __webpack_require__("ycBI");
function injectStyle (ssrContext) {
  __webpack_require__("1byw")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */
var __vue_template__ = null
/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DemoBuilder_vue__["a" /* default */],
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "140p":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "1byw":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "1yAi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('md-list',_vm._l((Object.entries(_vm.sett._options)),function(ref){
var name = ref[0];
var opt = ref[1];
return (_vm.isDisplay(name))?_c('md-list-item',{key:name,staticClass:"md-inset"},[_c('v-input',{attrs:{"value":_vm.values[name],"name":opt.name,"type":_vm.sett._typeDefine(name),"enum":opt.enum,"txtDescr":opt.txtDescr,"txtEditable":opt.txtEditable,"txtEnable":opt.txtEnable,"txtError":_vm.errors[name],"isRequired":_vm.sett._isRequired(name),"isEditable":_vm.sett._isEditable(name),"isEnabled":_vm.sett._isEnabled(name),"isPassword":opt.isPassword,"lengthShortMax":_vm.lengthShortMax,"tooltipPos":_vm.tooltipPos},on:{"edited":function (value) { return _vm.update(name, value); }}})],1):_vm._e()}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "4Fru":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray__ = __webpack_require__("d7EF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_entries__ = __webpack_require__("W3Iv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__ = __webpack_require__("Zrlr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__ = __webpack_require__("wxAW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_column_description__ = __webpack_require__("HZLY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_data_types_mysql__ = __webpack_require__("w1YS");








var Column = function () {
    function Column() {
        __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, Column);

        this.set({});
        // TODO add support for pasing MySQL fks and enums
    }

    __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default()(Column, [{
        key: 'set',
        value: function set() {
            var col = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

            return this.parse(col);
        }
    }, {
        key: 'upd',
        value: function upd() {
            var _this = this;

            var col = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

            __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_entries___default()(col).filter(function (_ref) {
                var _ref2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default()(_ref, 2),
                    name = _ref2[0],
                    val = _ref2[1];

                return val !== undefined;
            }).forEach(function (_ref3) {
                var _ref4 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default()(_ref3, 2),
                    name = _ref4[0],
                    val = _ref4[1];

                return _this[name] = val;
            });
            return this.prepare();
        }
    }, {
        key: 'copy',
        value: function copy() {
            return {
                name: this.name,
                type: this.type,
                sub1: this.sub1,
                sub2: this.sub2,
                enum: this.enum,
                deft: this.deft,
                comm: this.comm,
                fkName: this.fkName,
                fkTbl: this.fkTbl,
                fkCol: this.fkCol,
                isPk: this.isPk,
                isUnsigned: this.isUnsigned,
                isNotNull: this.isNotNull,
                isNull: this.isNull,
                isUnique: this.isUnique,
                isIncrem: this.isIncrem,
                onUpdate: this.onUpdate,
                onDelete: this.onDelete
            };
        }
    }, {
        key: 'check',
        value: function check() {
            var tp = __WEBPACK_IMPORTED_MODULE_6__utils_data_types_mysql__["a" /* default */][this.type];
            if (!this.name) throw 'Name should be set';
            if (!this.type) throw 'Type should be set';
            if (!tp) throw 'Unknown type "' + this.type + '"';
            if (this.sub1 !== undefined && tp.sub1 === undefined) throw 'Sub1 option is not supported for "' + this.type + '"';
            if (this.sub2 !== undefined && tp.sub2 === undefined) throw 'Sub2 option is not supported for "' + this.type + '"';
            if (this.isUnsigned && !tp.unsigned) throw 'Unsigned option is not supported for "' + this.type + '"';
            if (this.comm && this.comm.length > 255) throw 'Comment can not contain more than 255 symbols';
            if (this.isNotNull && this.isNull) throw 'isNull and isNotNull can not be set at the same time';
            if (this.onUpdate && ['CASCADE', 'SET NULL', 'RESTRICT'].indexOf(this.onUpdate) < 0) throw 'Incorrect Update option "' + this.onUpdate + '"';
            if (this.onDelete && ['CASCADE', 'SET NULL', 'RESTRICT'].indexOf(this.onDelete) < 0) throw 'Incorrect Delete option "' + this.onDelete + '"';
            return this;
        }
    }, {
        key: 'prepare',
        value: function prepare() {
            if (this.type) this.type = this.type.toUpperCase();
            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
                for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_entries___default()(__WEBPACK_IMPORTED_MODULE_6__utils_data_types_mysql__["a" /* default */])), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                    var _ref5 = _step.value;

                    var _ref6 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default()(_ref5, 2);

                    var name = _ref6[0];
                    var desc = _ref6[1];

                    if (this.type == name) break;else if (desc.syn && desc.syn.indexOf(this.type) >= 0) {
                        this.type = name;
                        break;
                    }
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion && _iterator.return) {
                        _iterator.return();
                    }
                } finally {
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }

            return this;
        }
    }, {
        key: 'parse',
        value: function parse() {
            var col = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

            this.name = col.name;
            this.type = col.type;
            this.sub1 = col.sub1;
            this.sub2 = col.sub2;
            this.enum = col.enum;
            this.deft = col.deft;
            this.comm = col.comm;
            this.fkName = col.fkName;
            this.fkTbl = col.fkTbl;
            this.fkCol = col.fkCol;
            this.isPk = !!col.isPk;
            this.isUnsigned = !!col.isUnsigned;
            this.isNotNull = !!col.isNotNull;
            this.isNull = !!col.isNull;
            this.isUnique = !!col.isUnique;
            this.isIncrem = !!col.isIncrem;
            this.onUpdate = col.onUpdate;
            this.onDelete = col.onDelete;
            return this.prepare();
        }
    }, {
        key: 'parseMySQL',
        value: function parseMySQL(c) {
            this.name = c.Field;
            this.type = c.Type.split(' ')[0].split('(')[0].toUpperCase();
            this.sub1 = c.Type.indexOf('(') >= 0 ? c.Type.split('(')[1].split(')')[0].split(',')[0] : undefined;
            this.sub2 = c.Type.indexOf('(') >= 0 && c.Type.indexOf(',') >= 0 ? c.Type.split('(')[1].split(')')[0].split(',')[1] : undefined;
            this.enum = undefined;
            this.deft = c.Default;
            this.comm = c.Comment;
            this.fkTbl = undefined;
            this.fkCol = undefined;
            this.isPk = c.Key == 'PRI';
            this.isUnsigned = c.Type.indexOf('unsigned') >= 0;
            this.isNotNull = c.Null == 'NO';
            this.isNull = false;
            this.isUnique = c.Key == 'UNI';
            this.isIncrem = c.Extra.indexOf('auto_increment') >= 0;
            this.onUpdate = undefined;
            this.onDelete = undefined;
            return this.prepare();
        }
    }, {
        key: 'buildMySQL',
        value: function buildMySQL() {
            var esc = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function (name) {
                return name;
            };
            var escId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function (name) {
                return name;
            };

            var s = '';
            s += this.name ? '' + escId(this.name) : '';
            s += this.type ? ' ' + this.type : '';
            s += this.sub1 ? this.sub2 ? ' (' + this.sub1 + ',' : ' (' + this.sub1 + ')' : '';
            s += this.sub2 ? ' ' + this.sub2 + ')' : '';
            s += this.isUnsigned ? ' UNSIGNED' : '';
            s += this.enum ? ' (' + this.enum.map(function (e) {
                return esc(e);
            }).join(', ') + ')' : '';
            s += this.deft !== undefined ? ' DEFAULT ' + esc(this.deft) : '';
            s += this.comm ? ' COMMENT ' + esc(this.comm) : '';
            s += this.isPk ? ' PRIMARY KEY' : '';
            s += this.isNotNull ? ' NOT NULL' : '';
            s += this.isNull ? ' NULL' : '';
            s += this.isUnique && !this.isPk ? ' UNIQUE' : '';
            s += this.isIncrem ? ' AUTO INCREMENT' : '';
            return s;
        }
    }, {
        key: 'buildMySQL_fk',
        value: function buildMySQL_fk() {
            var esc = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function (name) {
                return name;
            };
            var escId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function (name) {
                return name;
            };

            var s = '';
            if (!this.fkTbl || !this.fkCol) return s;
            var fkName = escId(this.fkName ? this.fkName : this.fkTbl + '_' + this.fkCol);
            var fkTbl = escId(this.fkTbl);
            var fkCol = escId(this.fkCol);
            s += ' CONSTRAINT ' + fkName;
            s += ' FOREIGN KEY (' + this.name + ') REFERENCES ' + fkTbl + ' (' + fkCol + ')';
            if (this.onDelete) s += ' ON DELETE ' + this.onDelete;
            if (this.onUpdate) s += ' ON UPDATE ' + this.onUpdate;
            return s;
        }
    }, {
        key: 'prepareVal',
        value: function prepareVal(val) {
            if (val === undefined) val = this.deft;
            if (val === undefined) val = null;
            if (val === null && this.isNotNull) throw 'Value for column "' + colName + '" is required';
            if (this.enum && this.enum.indexOf(val) < 0) throw 'Value for column "' + colName + '" does not belong to enum';
            if (this.type == 'BOOLEAN') {
                if (typeof val == 'string') val = val.toLowerCase() == 'true' ? true : false;
                val = Boolean(val);
            }
            return val;
        }
    }]);

    return Column;
}();

/* harmony default export */ __webpack_exports__["a"] = (Column);

/***/ }),

/***/ "4JUt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dkbr-input"},[(_vm.descrFull)?_c('dkbr-tooltip',{attrs:{"text":_vm.descrFull,"dir":_vm.tooltipDir,"dt":100}}):_vm._e(),(_vm.displayIn == 'switch')?_c('md-switch',{class:['md-primary'],attrs:{"md-theme":_vm.isThInv ? _vm.th+'i' : _vm.th,"name":_vm.name,"disabled":!_vm.isEnabled || !_vm.isEditable},on:{"change":_vm.edited},model:{value:(_vm.value_),callback:function ($$v) {_vm.value_=$$v},expression:"value_"}},[_vm._v(_vm._s(_vm.name))]):_vm._e(),(_vm.displayIn == 'checkbox')?_c('md-checkbox',{class:['md-primary'],attrs:{"md-theme":_vm.isThInv ? _vm.th+'i' : _vm.th,"name":_vm.name,"disabled":!_vm.isEnabled || !_vm.isEditable},on:{"change":_vm.edited},model:{value:(_vm.value_),callback:function ($$v) {_vm.value_=$$v},expression:"value_"}},[_vm._v(_vm._s(_vm.name))]):_vm._e(),(['select', 'input', 'textarea'].indexOf(_vm.displayIn) >= 0)?_c('md-field',{class:['md-primary', {'md-invalid': _vm.txtError}],attrs:{"md-theme":_vm.isThInv ? _vm.th+'i' : _vm.th,"md-has-password":_vm.isPassword}},[_c('label',[_vm._v(_vm._s(_vm.name))]),(_vm.displayIn == 'select')?_c('md-select',{class:['md-primary', {'md-invalid': _vm.txtError}],attrs:{"md-theme":_vm.isThInv ? _vm.th+'i' : _vm.th,"multiple":_vm.type == 'array',"disabled":!_vm.isEnabled || !_vm.isEditable,"required":_vm.isRequired},on:{"change":_vm.edited},model:{value:(_vm.value_),callback:function ($$v) {_vm.value_=$$v},expression:"value_"}},_vm._l((this.enum),function(item,i){return _c('md-option',{key:i,attrs:{"disabled":false,"value":item}},[_vm._v(_vm._s(item))])})):_vm._e(),(_vm.displayIn == 'input')?_c('md-input',{class:['md-primary', {'md-invalid': _vm.txtError}],attrs:{"md-theme":_vm.isThInv ? _vm.th+'i' : _vm.th,"placeholder":_vm.name,"type":_vm.isPassword? 'password' : _vm.type=='number' ? 'number' : null,"maxlength":_vm.lengthMax>0 ? _vm.lengthMax : undefined,"disabled":!_vm.isEnabled,"readonly":!_vm.isEditable,"required":_vm.isRequired},on:{"blur":_vm.edited,"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key)){ return null; }_vm.edited($event)}},model:{value:(_vm.value_),callback:function ($$v) {_vm.value_=$$v},expression:"value_"}}):_vm._e(),(_vm.displayIn == 'textarea')?_c('md-textarea',{class:['md-primary', {'md-invalid': _vm.txtError}],attrs:{"md-theme":_vm.isThInv ? _vm.th+'i' : _vm.th,"placeholder":_vm.name,"maxlength":_vm.lengthMax>0 ? _vm.lengthMax : undefined,"disabled":!_vm.isEnabled,"readonly":!_vm.isEditable,"required":_vm.isRequired},on:{"change":_vm.edited},model:{value:(_vm.value_),callback:function ($$v) {_vm.value_=$$v},expression:"value_"}}):_vm._e(),_c('span',{staticClass:"md-error"},[_vm._v(_vm._s(_vm.txtError))])],1):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "4yE9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dt-nav",class:{'dt-nav_collapsed': _vm.isCollapsed}},[_c('transition',{attrs:{"name":"dt-nav__body1"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isCollapsed),expression:"!isCollapsed"}],staticClass:"dt-nav__body"},_vm._l((_vm.pages),function(route){return _c('router-link',{key:route.name,staticClass:"dt-nav__item",class:{
                    'dt-nav__item_pushed': _vm.$route.name == route.name
                },attrs:{"tag":"div","to":{name: route.name, params: route.params || {}}}},[_vm._v(_vm._s(route.title))])}))])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "5CWU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Deeptensor_vue__ = __webpack_require__("+H+X");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1c50e1f4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_Deeptensor_vue__ = __webpack_require__("ttFj");
function injectStyle (ssrContext) {
  __webpack_require__("G+N/")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Deeptensor_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1c50e1f4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_Deeptensor_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "68Nu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dkbr-link"},[_c('a',{staticClass:"str",attrs:{"href":_vm.isENG
            ? "http://www.skoltech.ru/en/about/contacts/"
            : "http://www.skoltech.ru/o-nas/kontakty/","target":"_blank"}},[_c('md-icon',{staticClass:"md-accent",staticStyle:{"margin-right":"10px","text-decoration":"underline"}},[_vm._v("drive_eta")]),(_vm.isENG)?_c('span',[_vm._v("Learn more how to reach us")]):_vm._e(),(_vm.isRUS)?_c('span',[_vm._v("Подробнее, как добраться")]):_vm._e()],1),(_vm.text)?_c('span',{staticClass:"dkbr-icon_text",class:['dkbr-icon__text_'+_vm.textDir],domProps:{"innerHTML":_vm._s(_vm.text)}}):_vm._e(),_c('md-icon',{staticClass:"dkbr-icon_icon",class:[
            'md-primary',
            'md-size-'+_vm.size+'x',
            _vm.source == 'fa' ? 'fa' : undefined,
            _vm.source == 'fa' ? 'fa-'+_vm.name : undefined],attrs:{"md-theme":_vm.isThInv ? _vm.th+'i' : _vm.th}},[_vm._v(_vm._s(_vm.source == 'gg' ? _vm.name : undefined))])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "6tGn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// https://vuematerial.io/ui-elements/elevation
// https://vuematerial.io/components/content
// https://vuematerial.io/ui-elements/scrollbar

/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'dkbr-frame',
    props: {
        th: {
            name: 'th',
            type: String,
            enum: ['th1', 'th2', 'th3', 'th4', 'th5', 'th6', 'th7'],
            txtDescr: 'Color theme of the element',
            default: function _default(_) {
                return 'th1';
            }
        },
        isThInv: {
            name: 'isThInv',
            type: Boolean,
            txtDescr: 'If is true, inversed color theme will be used',
            default: function _default(_) {
                return false;
            }
        },
        tag: {
            name: 'tag',
            type: String,
            txtDescr: 'Html tag for resulting element',
            default: function _default(_) {
                return 'div';
            }
        },
        elevation: {
            name: 'elevation',
            type: Number,
            txtDescr: 'Elevation (0..24)',
            validator: function validator(v) {
                return v >= 0 && v <= 24;
            },
            default: function _default(_) {
                return 0;
            }
        },
        isScrollbar: {
            name: 'isScrollbar',
            type: Boolean,
            txtDescr: 'If is true, scroll will be presented',
            default: function _default(_) {
                return false;
            }
        },
        w: {
            name: 'Width',
            type: Number,
            txtDescr: 'Width of the frame (in pixels)',
            validator: function validator(v) {
                return v >= 0;
            },
            default: function _default(_) {
                return 0;
            }
        },
        h: {
            name: 'Height',
            type: Number,
            txtDescr: 'Height of the frame (in pixels)',
            validator: function validator(v) {
                return v >= 0;
            },
            default: function _default(_) {
                return 0;
            }
        },
        m: {
            name: 'Margin',
            type: Number,
            txtDescr: 'Margin for the frame (in pixels)',
            validator: function validator(v) {
                return v >= 0;
            },
            default: function _default(_) {
                return 0;
            }
        },
        p: {
            name: 'Padding',
            type: Number,
            txtDescr: 'Padding for the frame (in pixels)',
            validator: function validator(v) {
                return v >= 0;
            },
            default: function _default(_) {
                return 0;
            }
        },
        colorBg: {
            name: 'Color (bg)',
            type: String,
            txtDescr: 'Color of the frame background',
            validator: function validator(v) {
                return true;
            },
            default: function _default(_) {
                return undefined;
            }
        },
        colorFg: {
            name: 'Color (fg)',
            type: String,
            txtDescr: 'Color of the frame foreground (text)',
            validator: function validator(v) {
                return true;
            },
            default: function _default(_) {
                return undefined;
            }
        }
    }
});

/***/ }),

/***/ "8olI":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "9V/t":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  app: {
    name: 'Application name',
    type: String,
    txtDescr: 'Name of the current application',
    default: function _default(v, sett) {
      return '';
    }
  },
  lengthMax: {
    name: 'Maximum saved messages',
    type: Number,
    txtDescr: 'Maximum number of saved messages',
    txtError: 'It should be non negative integer',
    validator: function validator(v, sett) {
      return v >= 0;
    },
    default: function _default(v, sett) {
      return 1000;
    }
  },
  fatal: {
    name: 'Save fatals',
    type: Boolean,
    txtDescr: 'If true, then fatal messages will be saved',
    default: function _default(v, sett) {
      return true;
    }
  },
  err: {
    name: 'Save errors',
    type: Boolean,
    txtDescr: 'If true, then error messages will be saved',
    default: function _default(v, sett) {
      return true;
    }
  },
  warn: {
    name: 'Save warnings',
    type: Boolean,
    txtDescr: 'If true, then warning messages will be saved',
    default: function _default(v, sett) {
      return true;
    }
  },
  res: {
    name: 'Save results',
    type: Boolean,
    txtDescr: 'If true, then operations result messages will be saved',
    default: function _default(v, sett) {
      return true;
    }
  },
  proc: {
    name: 'Save procceses',
    type: Boolean,
    txtDescr: 'If true, then operations proccess messages will be saved',
    default: function _default(v, sett) {
      return true;
    }
  },
  debug: {
    name: 'Save debug',
    type: Boolean,
    txtDescr: 'If true, then debug messages will be saved',
    default: function _default(v, sett) {
      return false;
    }
  },
  debugCn: {
    name: 'Save debug CN',
    type: Boolean,
    txtDescr: 'If true, debug messages from Connection module will be saved',
    default: function _default(v, sett) {
      return true;
    }
  },
  debugDb: {
    name: 'Save debug DB',
    type: Boolean,
    txtDescr: 'If true, debug messages from Database module will be saved',
    default: function _default(v, sett) {
      return true;
    }
  },
  debugRb: {
    name: 'Save debug RB',
    type: Boolean,
    txtDescr: 'If true, debug messages from Robot module will be saved',
    default: function _default(v, sett) {
      return true;
    }
  },
  debugSt: {
    name: 'Save debug ST',
    type: Boolean,
    txtDescr: 'If true, debug messages from Settings module will be saved',
    default: function _default(v, sett) {
      return true;
    }
  },
  write: {
    name: 'Print to browser console',
    type: Boolean,
    txtDescr: 'If true, then saved messages will be printed',
    default: function _default(v, sett) {
      return false;
    }
  },
  isServer: {
    name: 'Server',
    type: Boolean,
    txtDescr: 'Is true for server side instanse',
    editable: function editable(v, sett) {
      return false;
    },
    default: function _default(v, sett) {
      return false;
    }
  },
  isPlugin: {
    name: 'Plugin',
    type: Boolean,
    txtDescr: 'Is true for plugin side instanse',
    editable: function editable(v, sett) {
      return false;
    },
    default: function _default(v, sett) {
      return false;
    }
  },
  browser: {
    name: 'Browser',
    type: String,
    enum: ['chrome', 'safari', 'opera', 'firefox', 'explorer', 'unknown'],
    txtDescr: 'Name of the used browser',
    editable: function editable(v, sett) {
      return false;
    },
    enabled: function enabled(v, sett) {
      return !sett.isServer;
    },
    default: function _default(v, sett) {
      return 'unknown';
    }
  }
});

/***/ }),

/***/ "AICB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Text_vue__ = __webpack_require__("OgCl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_49da4c44_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_Text_vue__ = __webpack_require__("njXQ");
function injectStyle (ssrContext) {
  __webpack_require__("To5C")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Text_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_49da4c44_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_Text_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "AO1n":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.dir != 'none')?_c('md-tooltip',{class:{'md-primary': true,},attrs:{"md-theme":_vm.isThInv ? _vm.th+'i' : _vm.th,"md-direction":_vm.dir,"md-delay":_vm.dt,"md-active":_vm.isShow}},[_vm._t("default",[_c('span',[_vm._v(_vm._s(_vm.text))])])],2):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "AfmF":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "AmdL":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/logo_skoltech_eng.f5ac047.png";

/***/ }),

/***/ "AyYN":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "B0Ka":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/logo_minedu_rus.c540362.png";

/***/ }),

/***/ "BcKe":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dkbr-icon"},[(_vm.text)?_c('span',{staticClass:"dkbr-icon_text",class:['dkbr-icon__text_'+_vm.textDir],domProps:{"innerHTML":_vm._s(_vm.text)}}):_vm._e(),_c('md-icon',{staticClass:"dkbr-icon_icon",class:[
            'md-primary',
            'md-size-'+_vm.size+'x',
            _vm.source == 'fa' ? 'fa' : undefined,
            _vm.source == 'fa' ? 'fa-'+_vm.name : undefined],attrs:{"md-theme":_vm.isThInv ? _vm.th+'i' : _vm.th}},[_vm._v(_vm._s(_vm.source == 'gg' ? _vm.name : undefined))])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "BiuT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_material__ = __webpack_require__("Lgyv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_material___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_material__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuetify__ = __webpack_require__("3EgV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuetify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vuetify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_moment__ = __webpack_require__("mjDs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_clipboard2__ = __webpack_require__("wvfG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_clipboard2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_clipboard2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_googlemaps__ = __webpack_require__("8GWT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_head__ = __webpack_require__("RZCy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_head___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue_head__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__text_vue_Text_vue__ = __webpack_require__("AICB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__title_vue_Title_vue__ = __webpack_require__("N4eE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__link_vue_Link_vue__ = __webpack_require__("INqZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__icon_vue_Icon_vue__ = __webpack_require__("uQpO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__button_vue_Button_vue__ = __webpack_require__("bo10");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__button_vue_ButtonDial__ = __webpack_require__("Gml+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__progress_vue_Progress__ = __webpack_require__("a+2m");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__tooltip_vue_Tooltip__ = __webpack_require__("QIO+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__input_vue_Input__ = __webpack_require__("RYIR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__figure_vue_Figure__ = __webpack_require__("HwDu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__frame_vue_Frame__ = __webpack_require__("yYAx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_vue_googlemaps_dist_vue_googlemaps_css__ = __webpack_require__("G2FD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_vue_googlemaps_dist_vue_googlemaps_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_vue_googlemaps_dist_vue_googlemaps_css__);






















function comps_() {
    __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_material___default.a);
    __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_2_vuetify___default.a);
    __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_6_vue_head___default.a);
    __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_3_vue_moment___default.a);
    __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_4_vue_clipboard2___default.a);
    __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('dkbr-text', __WEBPACK_IMPORTED_MODULE_7__text_vue_Text_vue__["a" /* default */]);
    __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('dkbr-title', __WEBPACK_IMPORTED_MODULE_8__title_vue_Title_vue__["a" /* default */]);
    __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('dkbr-link', __WEBPACK_IMPORTED_MODULE_9__link_vue_Link_vue__["a" /* default */]);
    __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('dkbr-icon', __WEBPACK_IMPORTED_MODULE_10__icon_vue_Icon_vue__["a" /* default */]);
    __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('dkbr-button', __WEBPACK_IMPORTED_MODULE_11__button_vue_Button_vue__["a" /* default */]);
    __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('dkbr-button-dial', __WEBPACK_IMPORTED_MODULE_12__button_vue_ButtonDial__["a" /* default */]);
    __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('dkbr-progress', __WEBPACK_IMPORTED_MODULE_13__progress_vue_Progress__["a" /* default */]);
    __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('dkbr-tooltip', __WEBPACK_IMPORTED_MODULE_14__tooltip_vue_Tooltip__["a" /* default */]);
    __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('dkbr-input', __WEBPACK_IMPORTED_MODULE_15__input_vue_Input__["a" /* default */]);
    __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('dkbr-figure', __WEBPACK_IMPORTED_MODULE_16__figure_vue_Figure__["a" /* default */]);
    __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('dkbr-frame', __WEBPACK_IMPORTED_MODULE_17__frame_vue_Frame__["a" /* default */]);
    __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_5_vue_googlemaps__["a" /* default */], {
        load: {
            apiKey: 'AIzaSyB0HvlqbtfXpnS1rO4xMxXzPVrGQlWoVYA',
            libraries: ['places']
        }
    });
}

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].prototype.$bus = new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
    methods: {
        on: function on(name, func) {
            return this.$on(name, func);
        },
        once: function once(name) {
            return this.$once(name);
        },
        off: function off(name, func) {
            return this.$off(name, func);
        },
        emit: function emit(name) {
            return this.$emit(name);
        }
    }
});

/* harmony default export */ __webpack_exports__["a"] = (comps_);

/***/ }),

/***/ "Bw1y":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/logo_minedu_eng.0fce8ff.png";

/***/ }),

/***/ "CDhK":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Czq0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Nav_vue__ = __webpack_require__("KCcJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_36b97a2b_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_Nav_vue__ = __webpack_require__("4yE9");
function injectStyle (ssrContext) {
  __webpack_require__("140p")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Nav_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_36b97a2b_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_Nav_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "D8uv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('md-list',{class:{
            'md-dense': _vm.isDense,
            'md-double-line': _vm.lines == 2,
            'md-triple-line': _vm.lines == 3
        }},[_vm._t("default",_vm._l((_vm.items_),function(item,i){return _c('md-list-item',{key:i,class:{
                    'md-inset': _vm.isPaddItem && !item.icon
                }},[(item.icon)?_c('md-icon',[_vm._v(_vm._s(item.icon))]):_vm._e(),_c('div',{staticClass:"md-list-text-container"},[_c('span',[_vm._v(_vm._s(item.title))]),_c('span',[_vm._v(_vm._s(item.subtitle))])]),(item.action)?_c('md-button',{staticClass:"md-icon-button md-list-action"},[_c('md-icon',{staticClass:"md-primary"},[_vm._v("chat_bubble")])],1):_vm._e(),_c('md-divider',{class:{
                        'md-inset': _vm.isPaddItem && !item.icon
                    }})],1)}))],2)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "DDSk":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "DnpR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__("Zrlr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__("wxAW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__cs_Cs__ = __webpack_require__("O+/P");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__settings_Settings__ = __webpack_require__("V+2q");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__sett__ = __webpack_require__("IKfi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__database_Table__ = __webpack_require__("Vuh9");












var tm$ = function tm$(dt, data) {
    return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (r) {
        return setTimeout(function (_) {
            return r(data);
        }, dt);
    });
};

var Database = function () {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(Database, [{
        key: 'CLASS',
        get: function get() {
            return 'Database';
        }
    }]);

    function Database(CS) {
        var _this = this;

        var dbPath = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '/static/db/dt/';

        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Database);

        this.CS = CS;
        this.dbPath = dbPath;
        this.tblNames = ['team', 'journals', 'conferences', 'papers', 'plan', 'events'];
        this.tblNamesLoaded = [];
        this.isStarted = false;
        this.tblNames.forEach(function (tblName) {
            _this[tblName] = new __WEBPACK_IMPORTED_MODULE_8__database_Table__["a" /* default */](tblName);
        });
    }

    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(Database, [{
        key: 'start$',
        value: function start$() {
            var _this2 = this;

            this.isStarted = true;
            console.log('this.isStarted');
            //return
            return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a.all(this.tblNames.map(function (n) {
                return _this2.download$(n);
            }));
        }
    }, {
        key: 'download$',
        value: function download$(tblName) {
            var _this3 = this;

            this.CS.debug('Start loading "' + tblName + '"', this.CLASS, 'download$');
            var tbl = this[tblName];
            return __WEBPACK_IMPORTED_MODULE_7_axios___default.a.get(this.dbPath + tbl.name + '.json').then(function (res) {
                return tm$(2, res);
            }).then(function (res) {
                tbl.parse(res.data);
                tbl.isLoaded = true;
                _this3.tblNamesLoaded.push(tblName);
                _this3.CS.debug('Table "' + tblName + '" is loaded', _this3.CLASS, 'download$');
                return tbl;
            }).catch(function (err) {
                _this3.CS.err('Error while loading table "' + tblName + '"', _this3.CLASS, 'download$', err);
            }).then(function (res) {
                return tm$(2, res);
            }).then(function (res) {
                return _this3.parse$();
            });
        }
    }, {
        key: 'parse$',
        value: function parse$() {
            var _this4 = this;

            return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a.all(this.tblNames.map(function (tblName) {
                return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a.all(_this4.tblNames.map(function (tblNameRef) {
                    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a.resolve(_this4[tblName].extend(_this4[tblNameRef]));
                }));
            }));
        }
    }]);

    return Database;
}();

function mixin_() {
    var app = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'app';
    var isDebug = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

    var CS = new __WEBPACK_IMPORTED_MODULE_4__cs_Cs__["a" /* default */]({
        app: app,
        fatal: true,
        err: true,
        warn: true,
        res: true,
        proc: true,
        debug: true,
        debugCn: true,
        debugDb: true,
        debugRb: true,
        debugSt: true,
        write: isDebug
    });
    var ST = new __WEBPACK_IMPORTED_MODULE_5__settings_Settings__["a" /* default */](__WEBPACK_IMPORTED_MODULE_6__sett__["a" /* default */], {}, app, 'global');
    var DB = new Database(CS);

    __WEBPACK_IMPORTED_MODULE_3_vue__["a" /* default */].mixin({
        data: function data() {
            return {
                CS: CS,
                ST: ST,
                DB: DB,
                windowW: 0,
                windowH: 0
            };
        },

        computed: {
            CLASS: function CLASS() {
                return this.$options.name;
            },
            LANG: function LANG() {
                return this.ST ? this.ST.lang : 'en';
            },
            isENG: function isENG() {
                return this.LANG == 'en';
            },
            isRUS: function isRUS() {
                return this.LANG == 'ru';
            },
            teamTbl: function teamTbl() {
                return this.DB['team'];
            },
            journalsTbl: function journalsTbl() {
                return this.DB['journals'];
            },
            conferencesTbl: function conferencesTbl() {
                return this.DB['conferences'];
            },
            papersTbl: function papersTbl() {
                return this.DB['papers'];
            },
            planTbl: function planTbl() {
                return this.DB['plan'];
            },
            eventsTbl: function eventsTbl() {
                return this.DB['events'];
            }
        },
        watch: {
            LANG: function LANG() {
                this.$moment.locale(this.LANG);
                this.$emit('updateHead');
            }
        },
        created: function created() {
            //this.CS.debug(`***`, this.$options.name, 'created')
        },
        mounted: function mounted() {
            var _this5 = this;

            //this.CS.debug(`***`, this.CLASS, 'mounted')
            this.updWindowW();
            this.updWindowH();
            this.$nextTick(function (_) {
                window.addEventListener('resize', _this5.updWindowW);
                window.addEventListener('resize', _this5.updWindowH);
            });
            if (!this.DB.isStarted) this.DB.start$();
        },
        beforeDestroy: function beforeDestroy() {
            //this.CS.debug(`***`, this.CLASS, 'beforeDestroy')
            window.removeEventListener('resize', this.updWindowW);
            window.removeEventListener('resize', this.updWindowH);
        },
        destroyed: function destroyed() {
            //this.CS.debug(`***`, this.CLASS, 'destroyed')
        },

        methods: {
            updWindowW: function updWindowW() {
                this.windowW = parseInt(document.documentElement.clientWidth, 10);
            },
            updWindowH: function updWindowH() {
                this.windowH = parseInt(document.documentElement.clientHeight, 10);
            },
            _parseDate: function _parseDate(date) {
                var format = this.isENG ? 'MMMM D, YYYY' : 'D MMMM, YYYY';
                return this.$moment(date).format(format);
            }
        }
    });
}

/* harmony default export */ __webpack_exports__["a"] = (mixin_);

/***/ }),

/***/ "EBXw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{staticClass:"dkbr",attrs:{"id":"app"}},[_c('router-view')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "G+N/":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "G2FD":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "GXKz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Lang__ = __webpack_require__("jlvB");




/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'dt-header',
    components: {
        'dt-lang': __WEBPACK_IMPORTED_MODULE_0__Lang__["a" /* default */]
    },
    data: function data() {
        return {};
    }
});

/***/ }),

/***/ "Gml+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ButtonDial_vue__ = __webpack_require__("TAnr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0691b38e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_ButtonDial_vue__ = __webpack_require__("ZJyH");
function injectStyle (ssrContext) {
  __webpack_require__("qdhV")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ButtonDial_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0691b38e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_ButtonDial_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "HZLY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony default export */ var _unused_webpack_default_export = ({
    name: {
        name: 'Name',
        desc: 'Name of the column'
    },
    type: {
        name: 'Type',
        desc: 'Type of the column, ex. INT, DECIMAL, FLOAT, ...'
    },
    sub1: {
        name: 'Sub1',
        desc: 'First parameter for type, ex. DECIMAL(10, 2) -> 10'
    },
    sub2: {
        name: 'Sub2',
        desc: 'Second parameter for type, ex. DECIMAL(10, 2) -> 2'
    },
    enum: {
        name: 'Enum',
        desc: 'List of possible values, ex. ENUM("a", "b", "c")'
    },
    deft: {
        name: 'Default',
        desc: 'Данное свойство определяет (константное) значение по умолчанию для столбца, которое используется, если при вставке строки в таблицу значение столбца не задано явно (=undefined) (для TIMESTAMP по умолчанию можно задать переменную величину CURRENT_TIMESTAMP). Нельзя установить значение по умолчанию для столбцов с типом *BLOB, *TEXT, а также для числовых столбцов, для которых задано свойство AUTO_INCREMENT. Кроме того, нельзя использовать неопределенное значение по умолчанию (NULL), если для столбца задано свойство NOT NULL.'
    },
    comm: {
        name: 'Comment',
        desc: 'Произвольное текстовое описание столбца длиной до 255 символов'
    },
    fkTbl: {
        name: 'Foreign key ref. table',
        desc: ''
    },
    fkCol: {
        name: 'Foreign key ref. column',
        desc: ''
    },
    isPk: {
        name: 'Is Pk',
        desc: 'Is true for primary key'
    },
    isUnsigned: {
        name: 'Is Unsigned',
        desc: 'If true, when value is supposed to be non negative'
    },
    isNotNull: {
        name: 'Is Not Null',
        desc: 'Это свойство указывает, что в данном столбце не допускаются неопределенные значения (NULL)'
    },
    isNull: {
        name: 'Is Null',
        desc: 'Данное свойство указывает, что в столбце разрешены неопределенные значения (NULL). Задавать это свойство имеет смысл только для столбцов с типом TIMESTAMP, которые по умолчанию не допускают неопределенных значений'
    },
    isUnique: {
        name: 'Is Unique',
        desc: 'Is true for unique columns'
    },
    isIncrem: {
        name: 'Is Increm',
        desc: 'If true, when value will be auto incremented for new columns'
    },
    onUpdate: {
        name: 'On update',
        desc: 'Определяет действие при изменении значения в родительской таблице, на которую ссылается внешний ключ (варианты: CASCADE, SET NULL, RESTRICT). Задается только для столбца, являющегося внешним ключом'
    },
    onDelete: {
        name: 'On delete',
        desc: 'Определяет действие при удалении значения в родительской таблице, на которую ссылается внешний ключ (варианты: CASCADE, SET NULL, RESTRICT). Задается только для столбца, являющегося внешним ключом'
    }
});

/***/ }),

/***/ "HwDu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Figure_vue__ = __webpack_require__("aOXP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_831e4884_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_Figure_vue__ = __webpack_require__("sRjG");
function injectStyle (ssrContext) {
  __webpack_require__("CDhK")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Figure_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_831e4884_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_Figure_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "I6y0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'dkbr-title',
    props: {
        th: {
            name: 'th',
            type: String,
            enum: ['th1', 'th2', 'th3', 'th4', 'th5', 'th6', 'th7'],
            txtDescr: 'Color theme of the element',
            default: function _default(_) {
                return 'th1';
            }
        },
        isThInv: {
            name: 'isThInv',
            type: Boolean,
            txtDescr: 'If is true, inversed color theme will be used',
            default: function _default(_) {
                return false;
            }
        },
        name: {
            name: 'name',
            type: String,
            txtDescr: 'Icon name',
            default: function _default(_) {
                return 'menu';
            }
        },
        size: {
            name: 'size',
            type: Number,
            enum: [1, 2, 3, 4, 5],
            txtDescr: 'Icon size',
            default: function _default(_) {
                return 1;
            }
        },
        text: {
            name: 'text',
            type: String,
            txtDescr: 'Text near icon',
            default: function _default(_) {
                return '';
            }
        },
        textDir: {
            name: 'textDir',
            type: String,
            enum: ['right', 'left'],
            txtDescr: 'Text position relative to icon',
            default: function _default(_) {
                return 'right';
            }
        },
        source: {
            name: 'source',
            type: String,
            enum: ['gg', 'fa'],
            txtDescr: 'Icon source (google, font-awesome, etc.)',
            default: function _default(_) {
                return 'gg';
            }
        }
    }
});

/***/ }),

/***/ "IKfi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
    lang: {
        name: 'Language',
        type: String,
        enum: ['en', 'ru'],
        txtDescr: 'Current language',
        default: function _default(v, sett) {
            return 'en';
        }
    }
});

/***/ }),

/***/ "INqZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Link_vue__ = __webpack_require__("sy8i");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_28a53f04_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_Link_vue__ = __webpack_require__("68Nu");
function injectStyle (ssrContext) {
  __webpack_require__("vocj")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Link_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_28a53f04_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_Link_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "KCcJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'dt-nav',
    props: {
        pages: {
            type: Array,
            default: function _default(_) {
                return [];
            }
        }
    },
    data: function data() {
        return {
            isCollapsed: false
        };
    },

    watch: {
        windowW: function windowW() {
            if (this.windowW < 700 && !this.isCollapsed) this.toggle(700);
        },
        windowH: function windowH() {
            if (this.windowH < 500 && !this.isCollapsed) this.toggle(700);
        },
        $route: function $route() {
            if ((this.windowW < 700 || this.windowH < 500) && !this.isCollapsed) this.toggle(500);
        }
    },
    methods: {
        toggle: function toggle() {
            var _this = this;

            var dt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

            return;
            setTimeout(function (_) {
                _this.isCollapsed = !_this.isCollapsed;
            }, dt);
        }
    }
});

/***/ }),

/***/ "Khvp":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "LG8o":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Float_vue__ = __webpack_require__("P3ym");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fe13aff4_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_Float_vue__ = __webpack_require__("djQV");
function injectStyle (ssrContext) {
  __webpack_require__("puQD")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-fe13aff4"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Float_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fe13aff4_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_Float_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "M4CH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__DemoBuilder__ = __webpack_require__("/zAt");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__text_vue_Text__ = __webpack_require__("AICB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__title_vue_Title__ = __webpack_require__("N4eE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__link_vue_Link__ = __webpack_require__("INqZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__icon_vue_Icon__ = __webpack_require__("uQpO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__button_vue_Button__ = __webpack_require__("bo10");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__button_vue_ButtonDial__ = __webpack_require__("Gml+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__progress_vue_Progress__ = __webpack_require__("a+2m");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__tooltip_vue_Tooltip__ = __webpack_require__("QIO+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__input_vue_Input__ = __webpack_require__("RYIR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__figure_vue_Figure__ = __webpack_require__("HwDu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__frame_vue_Frame__ = __webpack_require__("yYAx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__float_vue_Float__ = __webpack_require__("LG8o");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__list_vue_List__ = __webpack_require__("Zt+X");


















/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'dkbr-demo',
    components: {
        'dkbr-demo-builder': __WEBPACK_IMPORTED_MODULE_0__DemoBuilder__["a" /* default */]
    },
    data: function data() {
        return {
            Elem: __WEBPACK_IMPORTED_MODULE_10__figure_vue_Figure__["a" /* default */],
            Elems: { Text: __WEBPACK_IMPORTED_MODULE_1__text_vue_Text__["a" /* default */], Title: __WEBPACK_IMPORTED_MODULE_2__title_vue_Title__["a" /* default */], Link: __WEBPACK_IMPORTED_MODULE_3__link_vue_Link__["a" /* default */], Icon: __WEBPACK_IMPORTED_MODULE_4__icon_vue_Icon__["a" /* default */], Button: __WEBPACK_IMPORTED_MODULE_5__button_vue_Button__["a" /* default */], ButtonDial: __WEBPACK_IMPORTED_MODULE_6__button_vue_ButtonDial__["a" /* default */], Progress: __WEBPACK_IMPORTED_MODULE_7__progress_vue_Progress__["a" /* default */], Tooltip: __WEBPACK_IMPORTED_MODULE_8__tooltip_vue_Tooltip__["a" /* default */], Input: __WEBPACK_IMPORTED_MODULE_9__input_vue_Input__["a" /* default */], Figure: __WEBPACK_IMPORTED_MODULE_10__figure_vue_Figure__["a" /* default */], Frame: __WEBPACK_IMPORTED_MODULE_11__frame_vue_Frame__["a" /* default */], Float: __WEBPACK_IMPORTED_MODULE_12__float_vue_Float__["a" /* default */], List: __WEBPACK_IMPORTED_MODULE_13__list_vue_List__["a" /* default */] }
        };
    }
});

/***/ }),

/***/ "MWSf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Settings__ = __webpack_require__("zqF6");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'v-settings-manager',
    components: {
        'v-settings': __WEBPACK_IMPORTED_MODULE_0__Settings__["a" /* default */]
    },
    props: {
        setts: {
            name: 'Settings list',
            type: Array,
            txtDescr: 'Array of the displayed settings',
            editable: function editable(_) {
                return false;
            },
            default: function _default(_) {
                return [];
            }
        }
    },
    created: function created() {
        console.log('Set Man', this.setts);
    }
});

/***/ }),

/***/ "N4eE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Title_vue__ = __webpack_require__("I6y0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_71d820fe_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_Title_vue__ = __webpack_require__("BcKe");
function injectStyle (ssrContext) {
  __webpack_require__("m2qh")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Title_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_71d820fe_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_Title_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "O+/P":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__("Zrlr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__("wxAW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__settings_Settings__ = __webpack_require__("V+2q");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__sett_js__ = __webpack_require__("9V/t");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Message_js__ = __webpack_require__("tsh4");







var Cs = function () {
  function Cs() {
    var settings = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, Cs);

    this.sett = new __WEBPACK_IMPORTED_MODULE_3__settings_Settings__["a" /* default */](__WEBPACK_IMPORTED_MODULE_4__sett_js__["a" /* default */], settings);
    this.messages = [];

    var agent = 'unknown';
    try {
      agent = navigator.userAgent;
    } catch (e) {}
    if (agent.indexOf("unknown") > -1) this.sett._set('browser', 'unknown');else if (agent.indexOf("Chrome") > -1) this.sett._set('browser', 'chrome');else if (agent.indexOf("Safari") > -1) this.sett._set('browser', 'safari');else if (agent.indexOf("Opera") > -1) this.sett._set('browser', 'opera');else if (agent.indexOf("Firefox") > -1) this.sett._set('browser', 'firefox');else if (agent.indexOf("MSIE") > -1) this.sett._set('browser', 'explorer');
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(Cs, [{
    key: 'messageLast',
    value: function messageLast() {
      if (!this.length) {
        this.fatal('Can not get message since list is empty', 'Cs', 'messageLast');
        return null;
      }
      return this.messages[this.length - 1];
    }
  }, {
    key: 'fatal',
    value: function fatal() {
      var txt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var cl = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
      var func = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
      var obj = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;

      return this.add(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({ txt: txt, cl: cl, func: func, obj: obj }, { name: 'fatal' }));
    }
  }, {
    key: 'err',
    value: function err() {
      var txt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var cl = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
      var func = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
      var obj = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;

      return this.add(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({ txt: txt, cl: cl, func: func, obj: obj }, { name: 'err' }));
    }
  }, {
    key: 'warn',
    value: function warn() {
      var txt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var cl = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
      var func = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
      var obj = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;

      return this.add(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({ txt: txt, cl: cl, func: func, obj: obj }, { name: 'warn' }));
    }
  }, {
    key: 'res',
    value: function res() {
      var txt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var cl = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
      var func = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
      var obj = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;

      return this.add(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({ txt: txt, cl: cl, func: func, obj: obj }, { name: 'res' }));
    }
  }, {
    key: 'proc',
    value: function proc() {
      var txt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var cl = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
      var func = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
      var obj = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;

      return this.add(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({ txt: txt, cl: cl, func: func, obj: obj }, { name: 'proc' }));
    }
  }, {
    key: 'debug',
    value: function debug() {
      var txt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var cl = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
      var func = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
      var obj = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;

      return this.add(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({ txt: txt, cl: cl, func: func, obj: obj }, { name: 'debug' }));
    }
  }, {
    key: 'debugCn',
    value: function debugCn() {
      var txt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var cl = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
      var func = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
      var obj = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;

      return this.add(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({ txt: txt, cl: cl, func: func, obj: obj }, { name: 'debugCn' }));
    }
  }, {
    key: 'debugDb',
    value: function debugDb() {
      var txt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var cl = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
      var func = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
      var obj = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;

      return this.add(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({ txt: txt, cl: cl, func: func, obj: obj }, { name: 'debugDb' }));
    }
  }, {
    key: 'debugRb',
    value: function debugRb() {
      var txt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var cl = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
      var func = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
      var obj = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;

      return this.add(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({ txt: txt, cl: cl, func: func, obj: obj }, { name: 'debugRb' }));
    }
  }, {
    key: 'debugSt',
    value: function debugSt() {
      var txt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var cl = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
      var func = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
      var obj = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;

      return this.add(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({ txt: txt, cl: cl, func: func, obj: obj }, { name: 'debugSt' }));
    }
  }, {
    key: 'add',
    value: function add() {
      var mess = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : { name: 'fatal', txt: '', cl: '', func: '', obj: null };

      var message = new __WEBPACK_IMPORTED_MODULE_5__Message_js__["a" /* default */](__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({ app: this.sett.app }, mess));
      if (!this.sett[mess.name]) return message;
      if (mess.name.startsWith('debug') && !this.sett['debug']) return message;
      this.messages.push(message);
      if (this.sett.lengthMax && this.length >= this.sett.lengthMax) this.messages.shift(); // TODO! Is it effective???
      if (this.sett.write) this.write(message.str());
      return message;
    }
  }, {
    key: 'write',
    value: function write(txt) {
      var obj = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

      if (obj && obj.str) txt += obj.str();
      if (obj && !obj.str) txt += obj.toString();
      if (this.sett.isPlugin && this.sett.browser == 'chrome') chrome.tabs.executeScript({ code: 'console.log(`' + txt + '`)' });else console.log(txt);
    }
  }, {
    key: 'length',
    get: function get() {
      return this.messages.length;
    }
  }]);

  return Cs;
}();

/* harmony default export */ __webpack_exports__["a"] = (Cs);

/***/ }),

/***/ "OgCl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'dkbr-text',
    props: {
        th: {
            name: 'th',
            type: String,
            enum: ['th1', 'th2', 'th3', 'th4', 'th5', 'th6', 'th7'],
            txtDescr: 'Color theme of the element',
            default: function _default(_) {
                return 'th1';
            }
        },
        isThInv: {
            name: 'isThInv',
            type: Boolean,
            txtDescr: 'If is true, inversed color theme will be used',
            default: function _default(_) {
                return false;
            }
        },

        text: {
            name: 'text',
            type: String,
            txtDescr: 'Text',
            default: function _default(_) {
                return '';
            }
        },
        display: {
            name: 'display',
            type: String,
            enum: ['none', 'inline', 'block'],
            txtDescr: 'Display mode',
            default: function _default(_) {
                return 'block';
            }
        },
        align: {
            name: 'align',
            type: String,
            enum: ['left', 'center', 'right', 'justify'],
            txtDescr: 'Text alignment',
            default: function _default(_) {
                return 'left';
            }
        },
        icon: {
            name: 'icon',
            type: String,
            txtDescr: 'Icon name',
            default: function _default(_) {
                return '';
            }
        },
        iconSize: {
            name: 'iconSize',
            type: Number,
            enum: [1, 2, 3, 4, 5],
            txtDescr: 'Icon size',
            default: function _default(_) {
                return 1;
            }
        },
        iconDir: {
            name: 'iconDir',
            type: String,
            enum: ['right', 'left'],
            txtDescr: 'Icon position relative to text',
            default: function _default(_) {
                return 'left';
            }
        }
    }
});

/***/ }),

/***/ "P3ym":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_Geom_js__ = __webpack_require__("/3jw");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  replace: true,
  name: 'v-float',
  props: {
    id: { type: [String, Number], default: '' },
    opened: { type: Boolean, default: true },
    closeSelf: { type: Boolean, default: true },
    absolute: { type: Boolean, default: true },
    drag: { type: Boolean, default: true },
    resize: { type: Boolean, default: true },
    maximize: { type: Boolean, default: true },
    header: { type: Boolean, default: true },
    headerBtnMax: { type: Boolean, default: true },
    headerBtnRes: { type: Boolean, default: true },
    headerBtnRej: { type: Boolean, default: true },
    axis: { type: String, default: 'both',
      validator: function validator(v) {
        return ['x', 'y', 'both'].indexOf(v) >= 0;
      }
    },
    markers: { type: Array,
      default: function _default() {
        return ['tl', 'tm', 'tr', 'mr', 'br', 'bm', 'bl', 'ml'];
      }
    },
    x: { type: Number, default: 0, validator: function validator(v) {
        return v >= 0;
      } },
    y: { type: Number, default: 0, validator: function validator(v) {
        return v >= 0;
      } },
    w: { type: Number, default: 200, validator: function validator(v) {
        return v >= 0;
      } },
    h: { type: Number, default: 200, validator: function validator(v) {
        return v >= 0;
      } },
    hh: { type: Number, default: 50, validator: function validator(v) {
        return v >= 0;
      } },
    hhmin: { type: Number, default: 150, validator: function validator(v) {
        return v >= 0;
      } },
    hwmin: { type: Number, default: 400, validator: function validator(v) {
        return v >= 0;
      } },
    minw: { type: Number, default: 100, validator: function validator(v) {
        return v >= 0;
      } },
    minh: { type: Number, default: 100, validator: function validator(v) {
        return v >= 0;
      } },
    maxw: { type: Number, default: 9999, validator: function validator(v) {
        return v >= 0;
      } },
    maxh: { type: Number, default: 9999, validator: function validator(v) {
        return v >= 0;
      } },
    deltx: { type: Number, default: 20, validator: function validator(v) {
        return v >= 0;
      } },
    delty: { type: Number, default: 20, validator: function validator(v) {
        return v >= 0;
      } },
    elP: { default: null },
    elC: { default: null },
    value: { default: '' },
    error: { default: '' }
  },
  data: function data() {
    return {
      geom: {
        x: {
          pos: this.elC ? this.elC.getBoundingClientRect().left : this.x,
          len: this.elC ? this.elC.clientWidth : this.w
        },
        y: {
          pos: this.elC ? this.elC.getBoundingClientRect().top : this.y,
          len: this.elC ? this.elC.clientHeight : this.h
        }
      },
      openedSelf: true,
      activated: false,
      dragging: false,
      resizing: false,
      maximized: false,
      handles: this.markers,
      handle: null,
      zIndex: 1,
      value_: this.value
    };
  },

  computed: {
    headerIsShow: function headerIsShow() {
      if (!this.header) return false;
      if (this.geom.x.len < this.hwmin) return false;
      if (this.geom.y.len < this.hhmin) return false;
      return true;
    },
    sizeParent: function sizeParent() {
      var elp = this.elP ? this.elP : document.body;
      return {
        x: parseInt(elp.clientWidth, 10),
        y: parseInt(elp.clientHeight, 10)
      };
    },
    sizeLim: function sizeLim() {
      var ext = this.sizeParent;
      var min = {
        x: this.minw <= ext.x ? this.minw : ext.x,
        y: this.minh <= ext.y ? this.minh : ext.y
      };
      var max = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({
        x: this.maxw >= min.x ? this.maxw : min.x
      }, 'x', this.maxh >= min.y ? this.maxh : min.y);
      return {
        x: { min: min.x, max: max.x },
        y: { min: min.y, max: max.y }
      };
    }
  },
  created: function created() {
    var _arr = ['tl', 'tm', 'tr'];

    for (var _i = 0; _i < _arr.length; _i++) {
      var h = _arr[_i];
      if (this.headerIsShow && this.handles.indexOf(h) >= 0) this.handles.splice(this.handles.indexOf(h), 1);
    }var _arr2 = ['mr', 'ml'];
    for (var _i2 = 0; _i2 < _arr2.length; _i2++) {
      var _h = _arr2[_i2];
      if (this.axis != 'x' && this.axis != 'both' && this.handles.indexOf(_h) >= 0) this.handles.splice(this.handles.indexOf(_h), 1);
    }var _arr3 = ['tm', 'bm'];
    for (var _i3 = 0; _i3 < _arr3.length; _i3++) {
      var _h2 = _arr3[_i3];
      if (this.axis != 'y' && this.axis != 'both' && this.handles.indexOf(_h2) >= 0) this.handles.splice(this.handles.indexOf(_h2), 1);
    }
  },
  mounted: function mounted() {
    this.Geom = new __WEBPACK_IMPORTED_MODULE_1__utils_Geom_js__["a" /* default */](this.geom, this.sizeParent, this.sizeLim);
    this.mousePos = { x: 0, y: 0 };
    this.mouseOff = { x: 0, y: 0 };
    this.mouseDown = false;
    var doc = document.documentElement;
    doc.addEventListener('mousedown', this._mouseDown, true);
    doc.addEventListener('mousemove', this._mouseMove, true);
    doc.addEventListener('mouseup', this._mouseUp, true);
    this.$bus.on('float#' + this.id + '.open', this._open);
  },
  beforeDestroy: function beforeDestroy() {
    var doc = document.documentElement;
    doc.removeEventListener('mousedown', this._mouseDown, true);
    doc.removeEventListener('mousemove', this._mouseMove, true);
    doc.removeEventListener('mouseup', this._mouseUp, true);
    this.$bus.off('float#' + this.id + '.open', this._open);
  },

  methods: {
    _mouseDown: function _mouseDown(e) {
      var handle = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

      this.mouseDown = true;
      this.handle = handle;
      if (this.handle) this.resizing = true;else this._activate(e);
    },
    _mouseMove: function _mouseMove(e) {
      var mousePosNew = {
        x: e.pageX || e.clientX + document.documentElement.scrollLeft,
        y: e.pageY || e.clientY + document.documentElement.scrollTop
      };
      var mouseMov = {
        x: mousePosNew.x - this.mousePos.x - this.mouseOff.x,
        y: mousePosNew.y - this.mousePos.y - this.mouseOff.y
      };
      var objMov = mouseMov;
      this.mousePos = mousePosNew;
      if (this.activated && this.mouseDown && !this.resizing) this.dragging = true;
      if (this.dragging) objMov = this._drag(e, mouseMov);
      if (this.resizing) objMov = this._resize(e, mouseMov);
      this.mouseOff = {
        x: objMov.x - mouseMov.x,
        y: objMov.y - mouseMov.y
      };
    },
    _mouseUp: function _mouseUp(e) {
      if (this.resizing) this.$emit('resized', this.geom);
      if (this.dragging) this.$emit('dragged', this.geom);
      if (this.activated && this.mouseDown && (this.dragging || this.resizing)) {
        this.activated = false;
        this.$emit('deactivated', this.geom);
      }
      this.handle = null;
      this.mouseDown = false;
      this.dragging = false;
      this.resizing = false;
    },
    _activate: function _activate(e) {
      var elRoot = !this.headerIsShow ? this.$el : this.$refs.floatHeader;
      var elCurr = e.target || e.srcElement;
      var isInside = elRoot.contains(elCurr);
      if (isInside && !this.activated) {
        this.activated = true;
        this.zIndex += 1;
        this.$emit('activated', this.geom);
      }
      if (!isInside && this.activated) {
        this.activated = false;
        this.$emit('deactivated', this.geom);
      }
    },
    _maximize: function _maximize(e) {
      var _this = this;

      if (this.maximized) {
        this.Geom.minimize({ x: this.deltx, y: this.delty });
        this.maximized = false;
        setTimeout(function () {
          return _this.$emit('minimized', _this.geom);
        }, 500);
      } else {
        this.Geom.maximize({ x: this.deltx, y: this.delty });
        this.maximized = true;
        setTimeout(function () {
          return _this.$emit('maximized', _this.geom);
        }, 500);
      }
    },
    _drag: function _drag(e) {
      var mouseMov = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : { x: 0, y: 0 };

      return this.Geom.move({
        x: this.axis === 'x' || this.axis === 'both' ? mouseMov.x : 0,
        y: this.axis === 'y' || this.axis === 'both' ? mouseMov.y : 0
      });
    },
    _resize: function _resize(e) {
      var mouseMov = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : { x: 0, y: 0 };

      var dir = {
        x: this.handle[1] == 'r' ? 1 : this.handle[1] == 'l' ? -1 : 0,
        y: this.handle[0] == 'b' ? 1 : this.handle[0] == 't' ? -1 : 0
      };
      var objRes = this.Geom.resize(mouseMov, dir);

      /*
      console.log('---- ', this.handle)
      console.log(this.dragging)
      console.log(this.resizing)
      console.log('mouse: ', mouseMov)
      console.log('obj x dlen:   ', objRes.x.dlen)
      console.log('obj x dpos:   ', objRes.x.dpos)
      console.log('dir:   ', dir)
      */
      return { x: objRes.x.dlen, y: objRes.y.dlen };
    },
    _open: function _open(e) {
      this.openedSelf = true;
      this.$emit('opened', this.geom);
    },
    _close: function _close(e) {
      var save = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

      this.openedSelf = false;
      var params = {
        geom: this.geom,
        save: save,
        value: this.value_,
        valueOld: this.value
      };
      if (this.closeSelf) this.$emit('closed', params);else this.$emit('close-request', params);
    }
  }
});

/***/ }),

/***/ "PGJD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dt-lang"},[_c('div',{staticClass:"dt-lang__label",class:{'dt-lang__label_curr': _vm.isRUS}},[_vm._v("RUS")]),_c('dkbr-button-dial',{staticClass:"dt-lang__button",attrs:{"posx":"center","posy":"top","dir":"bottom","icon":"language","iconSize":2,"isHover":true},nativeOn:{"click":function($event){_vm.toggleLang('click')},"mouseover":function($event){_vm.toggleLang('over')},"mouseleave":function($event){_vm.toggleLang('leave')}}}),_c('div',{staticClass:"dt-lang__label",class:{'dt-lang__label_curr': _vm.isENG}},[_vm._v("ENG")])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "QIO+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Tooltip_vue__ = __webpack_require__("kOb6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0ba589d4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_Tooltip_vue__ = __webpack_require__("AO1n");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Tooltip_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0ba589d4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_Tooltip_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "RVJ0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Footer_vue__ = __webpack_require__("euR2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_562a74c3_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_Footer_vue__ = __webpack_require__("pTJB");
function injectStyle (ssrContext) {
  __webpack_require__("VN/1")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Footer_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_562a74c3_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_Footer_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "RYIR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Input_vue__ = __webpack_require__("ybxW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_46bf1362_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_Input_vue__ = __webpack_require__("4JUt");
function injectStyle (ssrContext) {
  __webpack_require__("k4gc")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Input_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_46bf1362_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_Input_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "TAnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'dkbr-button-dial',
    txtDescr: 'Dial button. Default slot may be used for action-buttons',
    props: {
        th: {
            name: 'th',
            type: String,
            enum: ['th1', 'th2', 'th3', 'th4', 'th5', 'th6', 'th7'],
            txtDescr: 'Color theme of the element',
            default: function _default(_) {
                return 'th1';
            }
        },
        isThInv: {
            name: 'isThInv',
            type: Boolean,
            txtDescr: 'If is true, inversed color theme will be used',
            default: function _default(_) {
                return false;
            }
        },
        posx: {
            name: 'posx',
            type: String,
            enum: ['left', 'center', 'right'],
            txtDescr: 'X-position of the element',
            default: function _default(_) {
                return 'left';
            }
        },
        posy: {
            name: 'posy',
            type: String,
            enum: ['top', 'bottom'],
            txtDescr: 'Y-position of the element',
            default: function _default(_) {
                return 'top';
            }
        },
        dir: {
            name: 'dir',
            type: String,
            enum: ['top', 'bottom'],
            txtDescr: 'Direction of content expansion',
            default: function _default(_) {
                return 'top';
            }
        },
        effect: {
            name: 'effect',
            type: String,
            enum: ['fling', 'scale', 'opacity'],
            txtDescr: 'Effect then expands',
            default: function _default(_) {
                return 'fling';
            }
        },
        icon: {
            name: 'icon',
            type: String,
            txtDescr: 'Icon for display',
            default: function _default(_) {
                return 'add';
            }
        },
        iconFinal: {
            name: 'iconFinal',
            type: String,
            txtDescr: 'Icon for display then opened',
            default: function _default(_) {
                return '';
            }
        },
        iconSize: {
            name: 'iconSize',
            type: Number,
            enum: [1, 2, 3, 4, 5],
            txtDescr: 'Icon size',
            default: function _default(_) {
                return 1;
            }
        },
        isHover: {
            name: 'isHover',
            type: Boolean,
            txtDescr: 'If true, will opened on hover',
            default: function _default(_) {
                return false;
            }
        },
        isDemo: {
            name: 'isDemo',
            type: Boolean,
            txtDescr: 'If true, the demo content will be generated',
            default: function _default(_) {
                return false;
            }
        }
    }
});

/***/ }),

/***/ "To5C":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "V+2q":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof__ = __webpack_require__("pFYg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck__ = __webpack_require__("Zrlr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass__ = __webpack_require__("wxAW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass__);






function _getStorage() {
    var storage = window.localStorage;
    if (!storage) throw 'Can\'t use local storage';
    var x = '__storage_test__';
    storage.setItem(x, x);
    if (storage.getItem(x) !== x) throw 'Can\'t use local storage';
    storage.removeItem(x);
    if (storage.getItem(x) !== null) throw 'Can\'t use local storage';
    return storage;
}

var Settings = function () {
    __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass___default()(Settings, [{
        key: 'CLASS',
        get: function get() {
            return 'Settings';
        }
    }, {
        key: 'TITLE',
        get: function get() {
            return '' + this._name;
        }
    }, {
        key: 'NAME',
        get: function get() {
            return this._app + '-' + this._name + '-settings';
        }
    }]);

    function Settings() {
        var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var values = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var app = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'app';
        var name = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'sett';
        var check = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;

        __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck___default()(this, Settings);

        this._app = app;
        this._name = name;
        this._options = options;
        this._setAll(values, check);
    }

    __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass___default()(Settings, [{
        key: '_check',
        value: function _check(name) {
            var value = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;

            var opt = this._options[name];
            if (!opt) throw 'Option "' + name + '" does not exist';
            if (value === undefined && !opt.required) return undefined;
            if (value === undefined && opt.required) throw 'Value for "' + name + '" is required';
            var type = opt.type ? opt.type.name.toLowerCase() : undefined;
            if (type && ((typeof value === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof___default()(value)) !== 'object' && type !== (typeof value === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof___default()(value)) || (typeof value === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof___default()(value)) === 'object' && type !== 'array')) throw 'Invalid type "' + (typeof value === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof___default()(value)) + '" for "' + name + '"';
            if (opt.enum && opt.enum.indexOf(value) < 0) throw 'Value for "' + name + '" does not belong to enum';
            if (opt.validator && !opt.validator(value, this)) throw opt.txtError ? opt.txtError : 'Invalid value for "' + name + '"';
            return value;
        }
    }, {
        key: '_set',
        value: function _set(name) {
            var _name;

            var value = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
            var check = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

            var opt = this._options[name];
            if (check) value = this._check(name, value);
            if (value === undefined && opt.default) {
                value = opt.default(value, this);
                if (check) value = this._check(name, value);
            }
            if (this[name] && opt.type === Array) // For Vue.js reactivity system
                (_name = this[name]).splice.apply(_name, [0, this[name].length].concat(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default()(value)));else this[name] = value;
            return value;
        }
    }, {
        key: '_setDefault',
        value: function _setDefault(name) {
            var check = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

            return this._set(name, undefined, check);
        }
    }, {
        key: '_setAll',
        value: function _setAll() {
            var _this = this;

            var values = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
            var check = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

            __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(this._options).forEach(function (name) {
                _this._set(name, values[name], check);
            });
        }
    }, {
        key: '_add',
        value: function _add(name, value) {
            var opt = this._options[name];
            if (!this[name] || opt.type !== Array) throw 'Can not add ' + name + ' to non array';
            this[name].push(value);
        }
    }, {
        key: '_copy',
        value: function _copy() {
            var _this2 = this;

            var onlyEditable = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

            var values = {};
            __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(this._options).filter(function (name) {
                return !onlyEditable || _this2._isEditable(name);
            }).forEach(function (name) {
                values[name] = _this2[name];
            });
            return values;
        }
    }, {
        key: '_copyEditable',
        value: function _copyEditable() {
            return this._copy(true);
        }
    }, {
        key: '_isBoolean',
        value: function _isBoolean(name) {
            var opt = this._options[name];
            return opt && opt.type === Boolean ? true : false;
        }
    }, {
        key: '_isNumber',
        value: function _isNumber(name) {
            var opt = this._options[name];
            return opt && opt.type === Number ? true : false;
        }
    }, {
        key: '_isString',
        value: function _isString(name) {
            var opt = this._options[name];
            return opt && opt.type === String ? true : false;
        }
    }, {
        key: '_isArray',
        value: function _isArray(name) {
            var opt = this._options[name];
            return opt && opt.type === Array ? true : false;
        }
    }, {
        key: '_isEnum',
        value: function _isEnum(name) {
            var opt = this._options[name];
            return opt && opt.enum && opt.enum.length ? true : false;
        }
    }, {
        key: '_isInEnum',
        value: function _isInEnum(name, value) {
            var opt = this._options[name];
            return this._isEnum(name) && opt.enum.indexOf(value) >= 0;
        }
    }, {
        key: '_isRequired',
        value: function _isRequired(name) {
            var opt = this._options[name];
            return opt && opt.required ? true : false;
        }
    }, {
        key: '_isValid',
        value: function _isValid(name) {
            var opt = this._options[name];
            if (opt && (!opt.validator || opt.validator(this[name], this))) return true;
            return false;
        }
    }, {
        key: '_isEditable',
        value: function _isEditable(name) {
            var opt = this._options[name];
            if (opt && (!opt.editable || opt.editable(this[name], this))) return true;
            return false;
        }
    }, {
        key: '_isEnabled',
        value: function _isEnabled(name) {
            var opt = this._options[name];
            if (opt && (!opt.enabled || opt.enabled(this[name], this))) return true;
            return false;
        }
    }, {
        key: '_typeDefine',
        value: function _typeDefine(name) {
            var opt = this._options[name];
            var val = this[name];
            if (opt && opt.type) return opt.type.name.toLowerCase();
            if (val === null || val === undefined) return 'string';else return typeof val === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof___default()(val);
        }
    }, {
        key: '_save',
        value: function _save() {
            _getStorage().setItem(this.NAME, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this._copyEditable()));
        }
    }, {
        key: '_load',
        value: function _load() {
            var check = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

            this._setAll(JSON.parse(_getStorage().getItem(this.NAME)), check);
        }
    }]);

    return Settings;
}();

/* harmony default export */ __webpack_exports__["a"] = (Settings);


var SettingsEx = {
    // Name of the option that can be accessed as
    // Settings.variable or Settings[variable]
    variable: {
        name: 'My var', // Name to display in GUI
        type: String, // Type: one of
        // [Number, Boolean, String, Array, Object]
        enum: ['a', 'b'], // Possible values (or undefined)
        txtDescr: 'This is..', // Long description for GUI
        txtEditable: 'Can not', //  Text for non editable options
        txtEnable: 'Set before..', //  Text for non enabled options
        txtError: 'Incorrect..', // Message for GUI if validator return false
        // If is empty, then check function will
        // return `Invalid value for "@{variable}"`
        required: false, // If true, then value should be provided
        validator: function validator(v, sett) {
            // Validate provided value (or default value)
            return v.length > 0;
        }, // (may use values of the other settings)
        editable: function editable(v, sett) {
            // Check if option may be edited (if is
            return v.length > 0;
        }, // false, then only owner can change it)
        // (may use values of the other settings)
        enabled: function enabled(v, sett) {
            // Check if option is actual
            return v.length > 0;
        }, // (may use values of the other settings)
        default: function _default(v, sett) {
            return (// Will be set, if value isn't provided
                'x'
            );
        }, // (may use values of the other settings)
        isPassword: false // additional option for passwords

        // , other options go here
    } };

/***/ }),

/***/ "VN/1":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Vuh9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray__ = __webpack_require__("d7EF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_entries__ = __webpack_require__("W3Iv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__ = __webpack_require__("Zrlr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__ = __webpack_require__("wxAW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Column_js__ = __webpack_require__("4Fru");







var Table = function () {
    __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default()(Table, [{
        key: 'CLASS',
        get: function get() {
            return 'Table';
        }
    }]);

    function Table() {
        var name = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;

        __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, Table);

        this.name = name;
        this.pknm = undefined;
        this.cols = [];
        this.rows = [];
        this.isLoaded = false;
        this.isParsed = false;
        this.numParsed = 0;
        // TODO and check table function (correct rowNames vs colNames, etc.)
    }

    __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default()(Table, [{
        key: 'set',
        value: function set() {
            var tbl = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

            return this.parse(tbl);
        }
    }, {
        key: 'upd',
        value: function upd() {
            var _this = this;

            var tbl = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

            this.name = tbl.name !== undefined ? tbl.name : this.name;
            this.pknm = tbl.pknm !== undefined ? tbl.pknm : this.pknm // TODO check?
            (tbl.cols || []).forEach(function (col) {
                return _this.colUpd(col);
            })(tbl.rows || []).forEach(function (row) {
                return _this.rowUpd(row);
            });
            return this;
        }
    }, {
        key: 'copy',
        value: function copy() {
            var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : { withCols: true, withRows: true };

            var tbl = { name: this.name, pknm: this.pknm, opts: opts };
            if (opts.withCols) tbl.cols = this.cols.map(function (col) {
                return col.copy();
            });
            if (opts.withRows) tbl.rows = this.rows; // TODO Should it be a real copy?
            return tbl;
        }
    }, {
        key: 'parse',
        value: function parse() {
            var _this2 = this;

            var tbl = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

            this.name = tbl.name;
            this.pknm = tbl.pknm;
            if (!tbl.opts || tbl.opts.withCols) {
                // TODO what if columns changed (rows may be not correct!)
                // TODO check default depends on tbl.rows present
                this.cols.splice(0);
                (tbl.cols || []).forEach(function (col) {
                    return _this2.colAdd(col, undefined, false);
                });
            }
            if (!tbl.opts || tbl.opts.withRows) {
                this.rows.splice(0);
                (tbl.rows || []).forEach(function (row) {
                    return _this2.rowAdd(row);
                });
            }
            return this;
        }
    }, {
        key: 'getColInd',
        value: function getColInd() {
            var colName = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;
            var thrErr = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

            '\n            Search index of the column and return it if found,\n            or raise error if thrErr,\n            or return index of the last column (is -1 if empty!)\n        ';
            var ind = this.cols.findIndex(function (col) {
                return col.name === colName;
            });
            if (ind < 0 && thrErr) throw 'Column "' + colName + '" does not exist';
            return ind >= 0 ? ind : this.cols.length - 1;
        }
    }, {
        key: 'getRowInd',
        value: function getRowInd() {
            var _this3 = this;

            var rowName = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;
            var thrErr = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

            '\n            Search index of the row and return it if found,\n            or raise error if thrErr,\n            or return index of the last row (is -1 if empty!)\n        ';
            if (!this.pknm) throw 'Primary key is not set';
            var ind = this.rows.findIndex(function (row) {
                return row[_this3.pknm] == rowName;
            });
            if (ind < 0 && thrErr) throw 'Row "' + rowName + '" does not exist';
            return ind >= 0 ? ind : this.rows.length - 1;
        }
    }, {
        key: 'col',
        value: function col(colName) {
            var j = this.getColInd(colName);
            return this.cols[j];
        }
    }, {
        key: 'colAdd',
        value: function colAdd(col) {
            var colNameBefore = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
            var deftCheck = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

            col = new __WEBPACK_IMPORTED_MODULE_5__Column_js__["a" /* default */]().parse(col).check();
            var colName = col.name;
            if (this.cols.find(function (col) {
                return col.name == colName;
            })) throw 'Column "' + colName + '" is already exist';
            if (col.isPk && this.cols.find(function (col) {
                return col.isPk;
            })) throw 'Can\'t add second pk "' + colName + '"';
            if (col.deft !== undefined && col.deft !== null) this.rows.forEach(function (row) {
                row[colName] = col.deft;
            });else if (deftCheck && this.rows.length && col.isNotNull) throw 'Default value for column "' + colName + '" is required';
            var j = this.getColInd(colNameBefore, false) + 1;
            this.cols.splice(j, 0, col);
            this.pknm = col.isPk ? col.name : this.pknm;
        }
    }, {
        key: 'colUpd',
        value: function colUpd(col) {
            var colNameBefore = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;

            var j = this.getColInd(col.name);
            if (!this.cols[j].isPk && col.isPk === true) throw 'Can\'t update to pk "' + col.name + '"';
            if (this.cols[j].isPk && col.isPk === false) throw 'Can\'t delete pk while update "' + col.name + '"';
            col = new __WEBPACK_IMPORTED_MODULE_5__Column_js__["a" /* default */]().parse(this.cols[j]).upd(col).check();
            if (!colNameBefore) this.cols[j] = col;else {
                var jNew = this.getColInd(colNameBefore, false) + 1;
                this.cols.splice(j, 1);
                this.cols.splice(jNew, 0, col);
            }
        }
    }, {
        key: 'colDel',
        value: function colDel(colName) {
            var j = this.getColInd(colName);
            if (this.cols[j].isPk) throw 'Can\'t delete pk column "' + colName + '"';
            this.rows.forEach(function (row) {
                delete row[colName];
            });
            this.cols.splice(j, 1);
        }
    }, {
        key: 'row',
        value: function row(rowName) {
            var i = this.getRowInd(rowName);
            return this.rows[i];
        }
    }, {
        key: 'rowAdd',
        value: function rowAdd(row) {
            var _this4 = this;

            var rowNameBefore = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;

            var rowName = row[this.pknm];
            var i = this.getRowInd(rowNameBefore, false) + 1;
            if (this.rows.find(function (row) {
                return row[_this4.pknm] == rowName;
            })) throw 'Row "' + rowName + '" is already exists';
            this.cols.forEach(function (col) {
                var colName = col.name;
                var val = col.prepareVal(row[colName]);
                if (val !== undefined && val !== null) row[colName] = val;else delete row[colName];
            });
            this.rows.splice(i, 0, row);
        }
    }, {
        key: 'rowUpd',
        value: function rowUpd(row) {
            var _this5 = this;

            var rowName = row[this.pknm];
            var i = this.getRowInd(rowName);
            __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_entries___default()(row).forEach(function (_ref) {
                var _ref2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default()(_ref, 2),
                    colName = _ref2[0],
                    val = _ref2[1];

                var col = _this5.cols[_this5.getColInd(colName)];
                row[colName] = col.prepareVal(val);
            });
            __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_entries___default()(row).forEach(function (_ref3) {
                var _ref4 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default()(_ref3, 2),
                    colName = _ref4[0],
                    val = _ref4[1];

                if (val !== undefined && val !== null) _this5.rows[i][colName] = val;else delete _this5.rows[i][colName];
            });
        }
    }, {
        key: 'rowDel',
        value: function rowDel(rowName) {
            var i = this.getRowInd(rowName);
            this.rows.splice(i, 1);
        }
    }, {
        key: 'val',
        value: function val(colName, rowName) {
            var i = this.getRowInd(rowName);
            var j = this.getColInd(colName);
            return this.rows[i][colName];
        }
    }, {
        key: 'valUpd',
        value: function valUpd(colName, rowName) {
            var val = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
            var old = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : undefined;

            var i = this.getRowInd(rowName);
            var j = this.getColInd(colName);
            var col = this.cols[j];
            val = col.prepareVal(val);
            if (old !== undefined && old !== this.rows[i][colName]) throw 'Old value is not correct';
            if (val !== undefined && val !== null) this.rows[i][colName] = val;else delete this.rows[i][colName];
        }
    }, {
        key: 'extend',
        value: function extend(tblRef) {
            var _this6 = this;

            if (!this.isLoaded || this.isParsed || !tblRef.isLoaded) return;
            this.cols.forEach(function (col) {
                if (!col.fkTbl || col.fkTbl != tblRef.name) return;
                if (_this6.name == 'papers') console.log('parse');
                _this6.rows.forEach(function (row) {
                    var rowRef = undefined;
                    try {
                        row[col.name] = tblRef.row(row[col.name]);
                    } catch (err) {}
                });
                _this6.numParsed += 1;
            });
            if (this.numParsed == this.cols.filter(function (c) {
                return c.fkTbl;
            }).length) this.isParsed = true;
            if (this.name == 'papers') {
                console.log('extend ', this.name, tblRef.name, this.isParsed, this.cols.filter(function (c) {
                    return c.fkTbl;
                }).length);
            }
        }
    }, {
        key: 'str',
        value: function str() {
            var withCols = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
            var cellLen = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 12;

            var M = this.cols.length;
            var r = ('-'.repeat(cellLen) + '--').repeat(M) + '\n';
            var s = withCols ? this.strCols() : '';
            s += '\n    Content of the table ' + this.name + '\n' + r;
            this.cols.map(function (col) {
                return col.name;
            }).forEach(function (v) {
                s += ' ' + v + ' '.repeat(Math.max(0, cellLen - v.length - 1)) + ' |';
            });
            s += '\n' + r;
            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
                for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(this.rows), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                    var row = _step.value;
                    var _iteratorNormalCompletion2 = true;
                    var _didIteratorError2 = false;
                    var _iteratorError2 = undefined;

                    try {
                        for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(this.cols), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                            var col = _step2.value;

                            var v = row[col.name];
                            v = v === undefined ? 'UNDEF' : v;
                            v = v === null ? 'NULL' : v.toString();
                            s += ' ' + v + ' '.repeat(Math.max(0, cellLen - v.length - 1)) + ' |';
                        }
                    } catch (err) {
                        _didIteratorError2 = true;
                        _iteratorError2 = err;
                    } finally {
                        try {
                            if (!_iteratorNormalCompletion2 && _iterator2.return) {
                                _iterator2.return();
                            }
                        } finally {
                            if (_didIteratorError2) {
                                throw _iteratorError2;
                            }
                        }
                    }

                    s += '\n';
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion && _iterator.return) {
                        _iterator.return();
                    }
                } finally {
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }

            return s + r;
        }
    }, {
        key: 'strCols',
        value: function strCols() {
            var esc = function esc(name) {
                return '\'' + name + '\'';
            };
            var escId = function escId(name) {
                return '\'' + name + '\'';
            };
            var s = '\n    Columns of the table ' + this.name + '\n';
            this.cols.forEach(function (col) {
                var sql = col.buildMySQL(esc, escId);
                var sql_fk = col.buildMySQL_fk(esc, escId);
                if (sql_fk) sql += ' '.repeat(Math.max(0, 30 - sql.length)) + '  || FK: ';
                s += sql + sql_fk + '\n';
            });
            return s;
        }
    }]);

    return Table;
}();

/* harmony default export */ __webpack_exports__["a"] = (Table);

/***/ }),

/***/ "WWVF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dkbr-icon"},[(_vm.text)?_c('span',{staticClass:"dkbr-icon_text",class:['dkbr-icon__text_'+_vm.textDir],domProps:{"innerHTML":_vm._s(_vm.text)}}):_vm._e(),_c('md-icon',{staticClass:"dkbr-icon_icon",class:[
            'md-primary',
            'md-size-'+_vm.size+'x',
            _vm.source == 'fa' ? 'fa' : undefined,
            _vm.source == 'fa' ? 'fa-'+_vm.name : undefined],attrs:{"md-theme":_vm.isThInv ? _vm.th+'i' : _vm.th}},[_vm._v(_vm._s(_vm.source == 'gg' ? _vm.name : undefined))])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "X5Xj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// https://vuematerial.io/components/button

/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'dkbr-button',
    txtDescr: 'Button. Emit the "click" event on click. Default slot may be used instead of the "text" property',
    props: {
        th: {
            name: 'th',
            type: String,
            enum: ['th1', 'th2', 'th3', 'th4', 'th5', 'th6', 'th7'],
            txtDescr: 'Color theme of the element',
            default: function _default(_) {
                return 'th1';
            }
        },
        isThInv: {
            name: 'isThInv',
            type: Boolean,
            txtDescr: 'If is true, inversed color theme will be used',
            default: function _default(_) {
                return false;
            }
        },
        text: {
            name: 'text',
            type: String,
            txtDescr: 'Inner button text',
            default: function _default(_) {
                return '';
            }
        },
        desc: {
            name: 'desc',
            type: String,
            txtDescr: 'Helper text (description)',
            default: function _default(_) {
                return '';
            }
        },
        href: {
            name: 'href',
            type: String,
            txtDescr: 'Hyperlink (a tag will be used if set)',
            default: function _default(_) {
                return '';
            }
        },
        target: {
            name: 'target',
            type: String,
            enum: ['_self', '_blank'],
            txtDescr: 'Hyperlink target',
            txtEnable: 'Can be used only if "href" is set',
            enabled: function enabled(v, sett) {
                return sett.href;
            },
            default: function _default(_) {
                return '_self';
            }
        },
        icon: {
            name: 'icon',
            type: String,
            txtDescr: 'Button icon',
            default: function _default(_) {
                return '';
            }
        },
        iconSize: {
            name: 'iconSize',
            type: Number,
            enum: [1, 2, 3, 4, 5],
            txtDescr: 'Icon size',
            txtEnable: 'Can be used only if "icon" is set',
            enabled: function enabled(v, sett) {
                return sett.icon;
            },
            default: function _default(_) {
                return 1;
            }
        },
        iconSource: {
            name: 'iconSource',
            type: String,
            enum: ['gg', 'fa'],
            txtDescr: 'Icon source (google, font-awesome, etc.)',
            txtEnable: 'Can be used only if "icon" is set',
            enabled: function enabled(v, sett) {
                return sett.icon;
            },
            editable: function editable(_) {
                return false;
            },
            default: function _default(_) {
                return 'gg';
            }
        },
        tltpDir: {
            name: 'tltpDir',
            type: String,
            enum: ['top', 'right', 'bottom', 'left', 'none'],
            txtDescr: 'Tooltip direction with helper text (description)',
            default: function _default(_) {
                return 'bottom';
            }
        },
        tltpDt: {
            name: 'tltpDt',
            type: Number,
            txtDescr: 'Delay for tooltip with helper text (description)',
            default: function _default(_) {
                return 300;
            }
        },
        isRaised: {
            name: 'isRaised',
            type: Boolean,
            txtDescr: 'Raised button',
            default: function _default(_) {
                return false;
            }
        },
        isDense: {
            name: 'isDense',
            type: Boolean,
            txtDescr: 'Dense button',
            default: function _default(_) {
                return false;
            }
        },
        isRipple: {
            name: 'isRipple',
            type: Boolean,
            txtDescr: 'Ripple effect',
            default: function _default(_) {
                return true;
            }
        },
        isDisabled: {
            name: 'isDisabled',
            type: Boolean,
            txtDescr: 'Disable button',
            default: function _default(_) {
                return false;
            }
        }
    }
});

/***/ }),

/***/ "ZJyH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('md-speed-dial',{class:['md-primary', ("md-" + _vm.posy + "-" + _vm.posx)],attrs:{"md-theme":_vm.isThInv ? _vm.th+'i' : _vm.th,"md-direction":_vm.dir,"md-effect":_vm.effect,"md-event":_vm.isHover ? 'hover' : 'click'}},[_c('md-speed-dial-target',[(_vm.icon)?_c('dkbr-icon',{class:{'md-morph-initial': _vm.iconFinal},attrs:{"th":_vm.th,"isThInv":_vm.isThInv,"name":_vm.icon,"size":_vm.iconSize}}):_vm._e(),(_vm.iconFinal)?_c('dkbr-icon',{class:{'md-morph-final': _vm.iconFinal},attrs:{"th":_vm.th,"isThInv":_vm.isThInv,"name":_vm.iconFinal,"size":_vm.iconSize}}):_vm._e()],1),_c('md-speed-dial-content',[_vm._t("default",[(_vm.isDemo)?_c('dkbr-button',{attrs:{"th":_vm.th,"isThInv":_vm.isThInv,"icon":"directions"}}):_vm._e(),(_vm.isDemo)?_c('dkbr-button',{attrs:{"th":_vm.th,"isThInv":_vm.isThInv,"icon":"streetview"}}):_vm._e(),(_vm.isDemo)?_c('dkbr-button',{attrs:{"th":_vm.th,"isThInv":_vm.isThInv,"icon":"note"}}):_vm._e(),(_vm.isDemo)?_c('dkbr-button',{attrs:{"th":_vm.th,"isThInv":_vm.isThInv,"icon":"event"}}):_vm._e(),(_vm.isDemo)?_c('dkbr-button',{attrs:{"th":_vm.th,"isThInv":_vm.isThInv,"icon":"close"}}):_vm._e()])],2)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Zt+X":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_List_vue__ = __webpack_require__("kRp3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b26cce04_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_List_vue__ = __webpack_require__("D8uv");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_List_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b26cce04_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_List_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "a+2m":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Progress_vue__ = __webpack_require__("d0hG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2b239e5e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_Progress_vue__ = __webpack_require__("fGFL");
function injectStyle (ssrContext) {
  __webpack_require__("DDSk")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Progress_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2b239e5e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_Progress_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "aOXP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_carousel_3d__ = __webpack_require__("T2eB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_carousel_3d___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_carousel_3d__);


var _props;

// https://wlada.github.io/vue-carousel-3d/guide/


/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'dkbr-figure',
    components: { Carousel3d: __WEBPACK_IMPORTED_MODULE_1_vue_carousel_3d__["Carousel3d"], Slide: __WEBPACK_IMPORTED_MODULE_1_vue_carousel_3d__["Slide"] },
    props: (_props = {
        th: {
            name: 'th',
            type: String,
            enum: ['th1', 'th2', 'th3', 'th4', 'th5', 'th6', 'th7'],
            txtDescr: 'Color theme of the element',
            default: function _default(_) {
                return 'th1';
            }
        },
        isThInv: {
            name: 'isThInv',
            type: Boolean,
            txtDescr: 'If is true, inversed color theme will be used',
            default: function _default(_) {
                return false;
            }
        },
        isShow: {
            name: 'isShow',
            type: Boolean,
            txtDescr: 'Image(s) will be removed if false',
            default: function _default(_) {
                return true;
            }
        },
        src: {
            name: 'src',
            type: String,
            txtDescr: 'Image source',
            default: function _default(_) {
                return '';
            }
        },
        srcs: {
            name: 'srcs',
            type: Array,
            txtDescr: 'Image sources (carousel will be used if given)',
            default: function _default(_) {
                return [];
            }
        },
        alt: {
            name: 'alt',
            type: String,
            txtDescr: 'Alt text for image',
            default: function _default(_) {
                return '';
            }
        },
        txt: {
            name: 'txt',
            type: String,
            txtDescr: 'Caption for the image',
            default: function _default(_) {
                return '';
            }
        },
        is3D: {
            name: 'is3D',
            type: Boolean,
            txtDescr: 'If true, 3D carousel is used',
            default: function _default(_) {
                return true;
            }
        },
        isRepeat: {
            name: 'isRepeat',
            type: Boolean,
            txtDescr: 'Enable carousel infinite loop',
            default: function _default(_) {
                return true;
            }
        },
        isAuto: {
            name: 'isAuto',
            type: Boolean,
            txtDescr: 'Flag to enable autoplay',
            default: function _default(_) {
                return false;
            }
        },
        isArrows: {
            name: 'isArrows',
            type: Boolean,
            txtDescr: 'Show controls (left/right arrow)',
            default: function _default(_) {
                return false;
            }
        },
        isClick: {
            name: 'isClick',
            type: Boolean,
            txtDescr: 'Enable navigation by clicking on slide',
            default: function _default(_) {
                return true;
            }
        },
        autoPauseH: {
            name: 'autoPauseH',
            type: Boolean,
            txtDescr: 'TFlag to pause autoplay on hover',
            txtEnable: 'Can be used only if "isAuto"',
            enabled: function enabled(v, sett) {
                return sett.isAuto;
            },
            default: function _default(_) {
                return true;
            }
        },
        autoDt: {
            name: 'autoDt',
            type: Number,
            txtDescr: 'Time elapsed before advancing slide',
            txtEnable: 'Can be used only if "isAuto"',
            enabled: function enabled(v, sett) {
                return sett.isAuto;
            },
            default: function _default(_) {
                return 5000;
            }
        },
        animDt: {
            name: 'animDt',
            type: Number,
            txtDescr: 'Animation between slides in milliseconds',
            default: function _default(_) {
                return 500;
            }
        },
        count: {
            name: 'count',
            type: Number,
            txtDescr: 'Number of slides (required for dynamic slides)',
            default: function _default(_) {
                return 0;
            }
        },
        perspective: {
            name: 'perspective',
            type: Number,
            txtDescr: 'Slides perspective position',
            default: function _default(_) {
                return 50;
            }
        },
        countPage: {
            name: 'countPage',
            type: Number,
            txtDescr: 'Number of slides displayed on each page',
            default: function _default(_) {
                return 5;
            }
        },
        dir: {
            name: 'dir',
            type: String,
            enum: ['ltr', 'rtl', 'utd', 'dtu'],
            txtDescr: 'Animation direction',
            default: function _default(_) {
                return 'ltr';
            }
        },
        w: {
            name: 'w',
            type: Number,
            txtDescr: 'Figure width (if =0, will not be set)',
            default: function _default(_) {
                return 0;
            }
        },
        ws: {
            name: 'ws',
            type: Number,
            txtDescr: 'Slide width displayed in center of carousel',
            default: function _default(_) {
                return 0;
            }
        },
        hs: {
            name: 'hs',
            type: Number,
            txtDescr: 'Slide height displayed in center of carousel',
            default: function _default(_) {
                return 0;
            }
        },
        wc: {
            name: 'wc',
            type: Number,
            txtDescr: 'Set arrows target area width in pixels',
            txtEnable: 'Can be used only if "isArrows"',
            enabled: function enabled(v, sett) {
                return sett.isArrows;
            },
            default: function _default(_) {
                return 50;
            }
        },
        hc: {
            name: 'hc',
            type: Number,
            txtDescr: 'Set arrows target area height in pixels',
            txtEnable: 'Can be used only if "isArrows"',
            enabled: function enabled(v, sett) {
                return sett.isArrows;
            },
            default: function _default(_) {
                return 50;
            }
        },
        bd: {
            name: 'bd',
            type: Number,
            txtDescr: 'Slide border size in pixels',
            default: function _default(_) {
                return 0;
            }
        }
    }, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_props, 'bd', {
        name: 'bd',
        type: Number,
        txtDescr: 'Slide border size in pixels',
        default: function _default(_) {
            return 0;
        }
    }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_props, 'sp', {
        name: 'sp',
        type: Number,
        txtDescr: 'Space between slides in pixels',
        default: function _default(_) {
            return 0;
        }
    }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_props, 'scaling', {
        name: 'scaling',
        type: Number,
        txtDescr: 'Slide inverse scaling',
        default: function _default(_) {
            return 300;
        }
    }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_props, 'swipe', {
        name: 'swipe',
        type: Number,
        txtDescr: 'Minimum distance in pixels to swipe before a slide advance is triggered',
        default: function _default(_) {
            return 10;
        }
    }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_props, 'sl', {
        name: 'sl',
        type: Number,
        txtDescr: 'Start slide index. First slide has 0 index',
        default: function _default(_) {
            return 0;
        }
    }), _props),
    computed: {
        isMulty: function isMulty() {
            return this.srcs_.length > 1;
        },
        src_: function src_() {
            if (this.src) return this.src;
            if (this.srcs && this.srcs.length >= 1) return this.srcs[0];
        },
        srcs_: function srcs_() {
            if (this.srcs.length) return this.srcs;
            if (this.src) return [this.src];
            return [];
        }
    },
    methods: {
        srcParse: function srcParse(src) {
            console.log('source: ', src);
            if (!src) return undefined;
            //src = `pictures/${src}`
            return src;
        }
    }
});

/***/ }),

/***/ "bo10":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Button_vue__ = __webpack_require__("X5Xj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3fd41efe_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_Button_vue__ = __webpack_require__("matE");
function injectStyle (ssrContext) {
  __webpack_require__("AyYN")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Button_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3fd41efe_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_Button_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "c1fE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Demo_vue__ = __webpack_require__("M4CH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0cd832c4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_Demo_vue__ = __webpack_require__("ktxt");
function injectStyle (ssrContext) {
  __webpack_require__("Khvp")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Demo_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0cd832c4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_Demo_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ceDw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'dt-lang',
    data: function data() {
        return {
            isOver: false,
            isClicked: false
        };
    },

    methods: {
        toggleLang: function toggleLang() {
            var mod = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;

            if (mod == 'over') {
                if (this.isOver) return;else this.isOver = true;
            }
            if (mod == 'leave') {
                this.isOver = false;
                if (this.isClicked) {
                    this.isClicked = false;
                    return;
                }
            }
            if (mod == 'click') {
                this.isClicked = true;
                if (this.isOver) return;
            }
            this.ST._set('lang', this.isENG ? 'ru' : 'en');
            try {
                this.ST._save();
            } catch (err) {
                this.CS.err('Can\'t save settings', this.CLASS, 'toggleLang', err);
            }
        }
    }
});

/***/ }),

/***/ "cgvj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('md-content',{class:[
        'md-primary',
        _vm.elevation ? 'md-elevation-'+_vm.elevation : undefined,
        {'md-scrollbar': _vm.isScrollbar,}
    ],style:({
        width: _vm.w ? _vm.w + 'px' : undefined,
        height: _vm.h ? _vm.h + 'px' : undefined,
        margin: _vm.m ? _vm.m + 'px' : undefined,
        padding: _vm.p ? _vm.p + 'px' : undefined,
        backgroundColor: _vm.colorBg,
        color: _vm.colorFg,
    }),attrs:{"md-tag":_vm.tag,"md-theme":_vm.isThInv ? _vm.th+'i' : _vm.th}},[_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "d0hG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'dkbr-progress',
    props: {
        th: {
            name: 'th',
            type: String,
            enum: ['th1', 'th2', 'th3', 'th4', 'th5', 'th6', 'th7'],
            txtDescr: 'Color theme of the element',
            default: function _default(_) {
                return 'th1';
            }
        },
        isThInv: {
            name: 'isThInv',
            type: Boolean,
            txtDescr: 'If is true, inversed color theme will be used',
            default: function _default(_) {
                return false;
            }
        },
        isInf: {
            name: 'isInf',
            type: Boolean,
            txtDescr: 'If is true, then infinite type is used',
            default: function _default(_) {
                return true;
            }
        },
        isSpinner: {
            name: 'isSpinner',
            type: Boolean,
            txtDescr: 'If is true, then spinnet type is used',
            default: function _default(_) {
                return false;
            }
        },
        d: {
            name: 'd',
            type: Number,
            txtDescr: 'Diameter',
            txtError: 'It should be non negative number',
            validator: function validator(v, sett) {
                return v >= 0;
            },
            enabled: function enabled(v, sett) {
                return sett.isSpinner;
            },
            default: function _default(_) {
                return 50;
            }
        },
        h: {
            name: 'h',
            type: Number,
            txtDescr: 'Spinner line width',
            txtError: 'It should be non negative number',
            validator: function validator(v, sett) {
                return v >= 0;
            },
            enabled: function enabled(v, sett) {
                return sett.isSpinner;
            },
            default: function _default(_) {
                return 3.5;
            }
        },
        value: {
            name: 'value',
            type: Number,
            txtDescr: 'Current progress value',
            txtError: 'It should be a number from 0 to 100',
            validator: function validator(v, sett) {
                return v >= 0 && v <= 100;
            },
            enabled: function enabled(v, sett) {
                return !sett.isInf;
            },
            default: function _default(_) {
                return 50;
            }
        },
        title: {
            name: 'title',
            type: String,
            txtDescr: 'Title for progress',
            default: function _default(_) {
                return '';
            }
        },
        titlePos: {
            name: 'titlePos',
            type: String,
            enum: ['top', 'right', 'bottom', 'left'],
            txtDescr: 'Title position relative to progress indicator',
            default: function _default(_) {
                return 'top';
            }
        },
        titleAlign: {
            name: 'Title alignment',
            type: String,
            enum: ['left', 'center', 'right'],
            txtDescr: 'Title alignment in the string',
            default: function _default(_) {
                return 'center';
            }
        }
    }
});

/***/ }),

/***/ "djQV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"show",rawName:"v-show",value:((!_vm.closeSelf && _vm.opened) || _vm.openedSelf),expression:"(!closeSelf && opened) || openedSelf"}],staticClass:"float",style:({
    position: _vm.absolute ? 'absolute' : 'relative',
    left    : _vm.geom.x.pos + 'px',
    top     : _vm.geom.y.pos + 'px',
    width   : _vm.geom.x.len + 'px',
    height  : _vm.geom.y.len + 'px',
    zIndex  : _vm.zIndex,
    opacity : _vm.dragging ? 0.6 : 1
  }),on:{"keyup":[function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key)){ return null; }if(!$event.ctrlKey){ return null; }$event.stopPropagation();$event.preventDefault();_vm._close($event, true)},function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"esc",27,$event.key)){ return null; }$event.stopPropagation();$event.preventDefault();_vm._close($event, false)}]}},[_vm._l((_vm.handles),function(handle){return (_vm.resize && _vm.activated)?_c('div',{key:handle,staticClass:"float__handle",class:'float__handle_type_' + handle,on:{"mousedown":function($event){$event.stopPropagation();$event.preventDefault();_vm._mouseDown($event, handle)}}}):_vm._e()}),(_vm.headerIsShow)?_c('div',{ref:"floatHeader",staticClass:"float__header",class:{'float__header_drag': _vm.drag},style:({
      width: 100 + '%',
      height: _vm.hh + 'px'
    }),on:{"dblclick":function($event){$event.stopPropagation();$event.preventDefault();_vm.maximize && !_vm.headerBtnMax ? _vm._maximize($event):null}}},[_vm._t("header",[_c('div',{staticClass:"float__header-toolbar"},[_vm._t("header-toolbar",[_c('md-button',{staticClass:"md-icon-button"},[_c('md-icon',[_vm._v("content_copy")])],1),_c('md-button',{staticClass:"md-icon-button"},[_c('md-icon',[_vm._v("content_paste")])],1),_c('md-button',{staticClass:"md-icon-button"},[_c('md-icon',[_vm._v("content_cut")])],1),_c('md-button',{staticClass:"md-icon-button"},[_c('md-icon',[_vm._v("clear")])],1)])],2),_c('div',{staticClass:"float__header-toolbar_main"},[(_vm.headerBtnMax)?_c('md-button',{staticClass:"float__header-btn-max md-icon-button md-primary",attrs:{"disabled":!_vm.maximize},on:{"click":function($event){$event.stopPropagation();$event.preventDefault();_vm._maximize($event)}}},[_c('md-icon',[_vm._v(_vm._s(!_vm.maximized ? 'zoom_out_map' : 'fullscreen_exit'))]),_c('md-tooltip',{attrs:{"md-direction":"bottom"}},[_vm._v(_vm._s(!_vm.maximized ? 'Maximize window' : 'Minimize window'))])],1):_vm._e(),(_vm.headerBtnRes)?_c('md-button',{staticClass:"float__header-btn-res md-icon-button md-primary",on:{"click":function($event){$event.stopPropagation();$event.preventDefault();_vm._close($event, true)}}},[_c('md-icon',[_vm._v("save")]),_c('md-tooltip',{attrs:{"md-direction":"bottom"}},[_vm._v("Save and Close (shortcut: ctrl+enter)")])],1):_vm._e(),(_vm.headerBtnRej)?_c('md-button',{staticClass:"float__header-btn-rej md-icon-button md-primary",on:{"click":function($event){$event.stopPropagation();$event.preventDefault();_vm._close($event, false)}}},[_c('md-icon',[_vm._v("cancel")]),_c('md-tooltip',{attrs:{"md-direction":"bottom"}},[_vm._v("Reject (shortcut: esc)")])],1):_vm._e()],1)])],2):_vm._e(),_c('div',{staticClass:"float__content",class:{'float__content_drag': _vm.drag && !_vm.headerIsShow},style:({
      width: 100 +'%',
      height: _vm.headerIsShow ? (_vm.geom.y.len-_vm.hh)+'px' : _vm.geom.y.len+'px'
    }),on:{"dblclick":function($event){$event.stopPropagation();$event.preventDefault();_vm.maximize && !_vm.headerIsShow? _vm._maximize($event): null}}},[_vm._t("default",[_vm._t("content",[_c('md-input-container',{staticStyle:{"min-width":"100%","min-height":"100%"},attrs:{"md-input-invalid":false}},[_c('md-textarea',{staticClass:"float__text",attrs:{"debounce":300,"disabled":false,"maxlength":1000,"readonly":false,"autofocus":"autofocus"},model:{value:(_vm.value_),callback:function ($$v) {_vm.value_=$$v},expression:"value_"}}),(_vm.error)?_c('md-tooltip',{attrs:{"md-direction":"top","md-delay":"100"}},[_vm._v("Error. "+_vm._s(_vm.error))]):_vm._e()],1)])])],2)],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "eC7B":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Dikobraz__ = __webpack_require__("g9jg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__demo_vue_Demo__ = __webpack_require__("c1fE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__dt_Deeptensor__ = __webpack_require__("5CWU");





/* harmony default export */ __webpack_exports__["a"] = ([{
    //name: 'dkbr',
    path: '',
    component: __WEBPACK_IMPORTED_MODULE_0__Dikobraz__["a" /* default */],
    children: [{
        name: 'demo',
        path: 'demo',
        component: __WEBPACK_IMPORTED_MODULE_1__demo_vue_Demo__["a" /* default */],
        children: []
    }, {
        //name: 'dt',
        path: '',
        component: __WEBPACK_IMPORTED_MODULE_2__dt_Deeptensor__["a" /* default */],
        children: __WEBPACK_IMPORTED_MODULE_2__dt_Deeptensor__["a" /* default */].routes || []
    }]
}]);

/***/ }),

/***/ "euR2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'dt-footer'
});

/***/ }),

/***/ "fGFL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dkbr-progress",style:({
        position: 'relative',
        flexDirection: _vm.titlePos=='top' || _vm.titlePos=='bottom' ? 'column' : 'row'
    })},[_c('div',{staticClass:"dkbr-progress__title",style:({
            order: _vm.titlePos=='right' || _vm.titlePos=='bottom' ? 2 : 0,
            alignSelf: _vm.titleAlign=='left' ? 'flex-start' : _vm.titleAlign=='center' ? 'center' : 'flex-end'
        })},[_vm._t("default",[_c('p',[_vm._v(_vm._s(_vm.title))])])],2),(_vm.isSpinner)?_c('md-progress-spinner',{staticClass:"dkbr-progress__obj",class:{'md-primary': true,},attrs:{"md-theme":_vm.isThInv ? _vm.th+'i' : _vm.th,"md-mode":_vm.isInf ? 'indeterminate' : 'determinate',"md-indeterminate":_vm.isInf,"md-diameter":_vm.d,"md-stroke":_vm.h,"md-value":_vm.value}}):_c('md-progress-bar',{staticClass:"dkbr-progress__obj",class:{'md-primary': true,},attrs:{"md-theme":_vm.isThInv ? _vm.th+'i' : _vm.th,"md-mode":_vm.isInf ? 'indeterminate' : 'determinate',"md-value":_vm.value}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "foHI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__("Zrlr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__("wxAW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__animation_js__ = __webpack_require__("ycBr");





/* GeomAxis : keep and modify position and length of 1D object
 *
 *
 *           <------------- lim.max ------------->
 *           <--- lim.min --->
 * |---------|===============^============|------^-----------|
 * 0         pos                                             ext
 *           <----------- len ------------>
 *
 * Only object {pos, len} is modified.
 * Auto checked:
 *              0 <= pos, lim.min <= len <= lim.max, pos+len <= ext
*/

var GeomAxis = function () {
  function GeomAxis() {
    var obj = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : { pos: 0, len: 0 };
    var ext = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
    var lim = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, GeomAxis);

    this.obj = obj;
    this.ext = ext !== undefined ? ext : 99999;
    this.lim = {
      min: lim.min !== undefined ? lim.min : 0,
      max: lim.max !== undefined ? lim.max : this.ext
    };
    this.check();
    this.save();
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(GeomAxis, [{
    key: 'save',
    value: function save() {
      this.old = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, this.obj);
    }
  }, {
    key: 'check',
    value: function check() {
      var res = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

      if (this.lim.min > this.ext || this.lim.min < 0) throw 'Incorrect lim min';
      if (this.lim.max < this.lim.min) throw 'Incorrect lim max';
      if (this.obj.pos < 0) {
        this.obj.pos = 0;
        res = false;
      }
      if (this.obj.len < this.lim.min) {
        this.obj.len = this.lim.min;
        res = false;
      }
      if (this.obj.len > this.lim.max) {
        this.obj.len = this.lim.max;
        res = false;
      }
      if (this.obj.len > this.ext) {
        this.obj.len = this.ext;
        res = false;
      }
      if (this.obj.pos + this.obj.len > this.ext) {
        this.obj.pos = this.ext - this.obj.len;
        res = false;
      }
      return res;
    }
  }, {
    key: 'move',
    value: function move() {
      var dpos = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

      this.save();
      this.obj.pos += dpos;
      this.check();
      return this.getPosDelt();
    }
  }, {
    key: 'moveTo',
    value: function moveTo() {
      var pos = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      pos = pos !== null ? pos : this.obj.pos;
      return this.move(pos - this.obj.pos);
    }
  }, {
    key: 'resize',
    value: function resize() {
      var dlen = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      var dir = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;

      this.save();
      if (dir > 0) {
        this.obj.len += dlen;
      }
      if (dir < 0) {
        this.obj.pos += dlen;
        this.obj.len -= dlen;
      }
      if (this.obj.pos + this.obj.len > this.ext) this.obj.len = this.ext - this.obj.pos;
      this.check();
      return {
        dpos: this.getPosDelt(),
        dlen: this.getLenDelt()
      };
    }
  }, {
    key: 'resizeTo',
    value: function resizeTo() {
      var len = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      var dir = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;

      len = len !== null ? len : this.obj.len;
      return this.resize(len - this.obj.len, dir);
    }
  }, {
    key: 'increase',
    value: function increase() {
      var delt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;

      this.save();
      this.obj.len += delt * 2;
      this.obj.pos -= delt;
      this.check();
      return this.getLenDelt();
    }
  }, {
    key: 'maximize',
    value: function maximize() {
      var _this = this;

      var delt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;

      Object(__WEBPACK_IMPORTED_MODULE_3__animation_js__["a" /* default */])(function () {
        return _this.increase(delt);
      });
    }
  }, {
    key: 'minimize',
    value: function minimize() {
      var _this2 = this;

      var delt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;

      Object(__WEBPACK_IMPORTED_MODULE_3__animation_js__["a" /* default */])(function () {
        return _this2.increase(-delt);
      });
    }
  }, {
    key: 'getPosDelt',
    value: function getPosDelt() {
      return this.obj.pos - this.old.pos;
    }
  }, {
    key: 'getLenDelt',
    value: function getLenDelt() {
      return this.obj.len - this.old.len;
    }
  }]);

  return GeomAxis;
}();

/* harmony default export */ __webpack_exports__["a"] = (GeomAxis);

/***/ }),

/***/ "fyb3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{staticClass:"dt-header"},[_c('router-link',{staticClass:"dt-header__logo",class:{
            'dt-header__logo_disabled': _vm.$route.name=='index'||_vm.$route.name==''},attrs:{"tag":"a","to":{name: 'dt-page-index'}}},[_c('dkbr-figure',{attrs:{"src":"/static/pictures/dt/icons/icon_logo.png"}})],1),_c('div',{staticClass:"dt-header__title"},[(_vm.isENG)?_c('span',[_vm._v("Tensor networks and deep learning"),_c('br'),_vm._v("for applications in data mining")]):_vm._e(),(_vm.isRUS)?_c('span',[_vm._v("Тензорные сети и глубинное обучение"),_c('br'),_vm._v("для интеллектуального анализа данных")]):_vm._e()]),_c('dt-lang',{staticClass:"dt-header__lang"})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "g9jg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Dikobraz_vue__ = __webpack_require__("xjJ1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5df86759_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_Dikobraz_vue__ = __webpack_require__("EBXw");
function injectStyle (ssrContext) {
  __webpack_require__("8olI")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Dikobraz_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5df86759_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_Dikobraz_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "jlvB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Lang_vue__ = __webpack_require__("ceDw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_73e198d4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_Lang_vue__ = __webpack_require__("PGJD");
function injectStyle (ssrContext) {
  __webpack_require__("qbl9")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Lang_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_73e198d4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_Lang_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "k4gc":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "kOb6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'dkbr-tooltip',
    txtDescr: 'Tooltip. Default slot may be used instead of the "text" property',
    props: {
        th: {
            name: 'th',
            type: String,
            enum: ['th1', 'th2', 'th3', 'th4', 'th5', 'th6', 'th7'],
            txtDescr: 'Color theme of the element',
            default: function _default(_) {
                return 'th1';
            }
        },
        isThInv: {
            name: 'isThInv',
            type: Boolean,
            txtDescr: 'If is true, inversed color theme will be used',
            default: function _default(_) {
                return false;
            }
        },
        text: {
            name: 'text',
            type: String,
            txtDescr: 'Text',
            default: function _default(_) {
                return '';
            }
        },
        dir: {
            name: 'dir',
            type: String,
            enum: ['top', 'right', 'bottom', 'left', 'none'],
            txtDescr: 'Direction',
            default: function _default(_) {
                return 'bottom';
            }
        },
        dt: {
            name: 'dt',
            type: Number,
            txtDescr: 'Delay for tooltip',
            default: function _default(_) {
                return 300;
            }
        },
        isShow: {
            name: 'isShow',
            type: Boolean,
            txtDescr: 'Will be shown if true',
            default: function _default(_) {
                return false;
            }
        }
    }
});

/***/ }),

/***/ "kRp3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__ = __webpack_require__("d7EF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__);



/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'v-list',
    props: {
        items: {
            name: 'Items',
            type: Array,
            txtDescr: '[:value] Items of the list (default slot may be used instead), each item is object like {icon=\'\', title: \'\', subtitle: \'\', iconAction: \'\', urlAction: \'\', divider: false}. Icon is placed on the left, then goes title, then subtitle (maybe on the next line), then action as button with icon and url, and then divider may be presented if true',
            default: function _default(_) {
                return [];
            }
        },
        itemsTitle: {
            name: 'Items (title)',
            type: Array,
            txtDescr: '[:itemsTitle]',
            default: function _default(_) {
                return [];
            }
        },
        itemsSubtitle: {
            name: 'Items (subtitle)',
            type: Array,
            txtDescr: '[:itemsSubtitle]',
            default: function _default(_) {
                return [];
            }
        },
        itemsIcon: {
            name: 'Items (icon)',
            type: Array,
            txtDescr: '[:itemsIcon]',
            default: function _default(_) {
                return [];
            }
        },
        itemsIconAction: {
            name: 'Items (icon action)',
            type: Array,
            txtDescr: '[:itemsIconAction]',
            default: function _default(_) {
                return [];
            }
        },
        itemsUrlAction: {
            name: 'Items (url action)',
            type: Array,
            txtDescr: '[:itemsUrlAction]',
            default: function _default(_) {
                return [];
            }
        },
        itemsDivider: {
            name: 'Items (divider)',
            type: Array,
            txtDescr: '[:itemsDivider]',
            default: function _default(_) {
                return [];
            }
        },
        lines: {
            name: 'Lines',
            type: Number,
            enum: [1, 2, 3],
            txtDescr: '[:lines] number of the lines for item',
            default: function _default(_) {
                return 1;
            }
        },
        isDense: {
            name: 'Is dense',
            type: Boolean,
            txtDescr: '[:isDense] If is true, then list will be dense',
            default: function _default(_) {
                return false;
            }
        },
        isPaddItem: {
            name: 'Is padding item',
            type: Boolean,
            txtDescr: '[:isPaddItem] If is true, then list items without icons will have additional padding',
            default: function _default(_) {
                return false;
            }
        }
    },
    computed: {
        items_: function items_() {
            var _this = this;

            return this.itemsTitle.map(function (_ref) {
                var _ref2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_ref, 2),
                    title = _ref2[0],
                    i = _ref2[1];

                return {
                    title: title,
                    subtitle: _this.itemsSubtitle[i],
                    icon: _this.itemsIcon[i],
                    iconAction: _this.itemsAction[i],
                    urlAction: _this.itemsUrlAction[i],
                    divider: _this.itemsDivider[i]
                };
            });
        }
    }
});

/***/ }),

/***/ "kmMG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__("/ocq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixin__ = __webpack_require__("DnpR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components__ = __webpack_require__("BiuT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__routes__ = __webpack_require__("eC7B");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Dikobraz__ = __webpack_require__("g9jg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_analytics__ = __webpack_require__("AYPi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_analytics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue_analytics__);







__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

Object(__WEBPACK_IMPORTED_MODULE_2__mixin__["a" /* default */])('deeptensor', true);
Object(__WEBPACK_IMPORTED_MODULE_3__components__["a" /* default */])();

var router = new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({ mode: 'history', routes: __WEBPACK_IMPORTED_MODULE_4__routes__["a" /* default */] });


__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_6_vue_analytics___default.a, {
    id: 'UA-110173242-1',
    router: router
});

var app = new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
    el: '#app',
    template: '<App/>',
    components: { App: __WEBPACK_IMPORTED_MODULE_5__Dikobraz__["a" /* default */] },
    router: router,
    render: function render(h) {
        return h(__WEBPACK_IMPORTED_MODULE_5__Dikobraz__["a" /* default */]);
    }
});

/***/ }),

/***/ "ktxt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dkbr-demo"},[_c('dkbr-button-dial',{attrs:{"th":"th2","posx":"right","posy":"bottom","dir":"top","effect":"fling","icon":"play_for_work","iconFinal":"add","md-direction":"top","isHover":false}},[_c('div',{staticClass:"dkbr-demo__menu"},_vm._l((Object.entries(_vm.Elems)),function(ref){
var name = ref[0];
var El = ref[1];
return _c('dkbr-button',{key:name,staticClass:"dkbr-demo__menu-item",attrs:{"text":name,"isRaised":true,"isPrimary":true},nativeOn:{"click":function($event){_vm.Elem = El}}})}))]),_vm._l((Object.entries(_vm.Elems)),function(ref){
var name = ref[0];
var El = ref[1];
return (El == _vm.Elem)?_c('dkbr-demo-builder',{key:name,staticClass:"dkbr-demo__content",attrs:{"Elem":El}}):_vm._e()})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "m2qh":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "mQWK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__input_vue_Input__ = __webpack_require__("RYIR");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'v-settings',
    components: {
        'v-input': __WEBPACK_IMPORTED_MODULE_1__input_vue_Input__["a" /* default */]
    },
    props: {
        sett: {
            name: 'Settings',
            type: Object,
            required: true,
            txtDescr: 'Settings instance for display',
            editable: function editable(_) {
                return false;
            }
        },
        onlyEnabled: {
            name: 'Only enabled',
            type: Boolean,
            txtDescr: 'If true, only enabled options will be presented',
            default: function _default(_) {
                return false;
            }
        },
        onlyEditable: {
            name: 'Only editable',
            type: Boolean,
            txtDescr: 'If true, only editable options will be presented',
            default: function _default(_) {
                return false;
            }
        },
        onlyRequired: {
            name: 'Only required',
            type: Boolean,
            txtDescr: 'If true, only required options will be presented',
            default: function _default(_) {
                return false;
            }
        },
        lengthShortMax: {
            name: 'Length max (short)',
            type: Number,
            txtDescr: 'If text is longer, input will be shown as textarea',
            default: function _default(_) {
                return 20;
            }
        },
        tooltipPos: {
            name: 'Tooltip position',
            type: String,
            enum: ['top', 'rigth', 'bottom', 'left', 'none'],
            txtDescr: 'Position of the tooltip (if is null, will not be shown)',
            default: function _default(_) {
                return 'right';
            }
        }
    },
    data: function data() {
        return {
            values: this.sett._copy(),
            errors: {}
        };
    },

    methods: {
        isDisplay: function isDisplay(name) {
            if (this.onlyEnabled && !this.sett._isEnabled(name)) return false;
            if (this.onlyEditable && !this.sett._isEditable(name)) return false;
            if (this.onlyRequired && !this.sett._isRequired(name)) return false;
            return true;
        },
        update: function update(name, value) {
            try {
                this.sett._set(name, value);
                this.errors[name] = undefined;
            } catch (err) {
                var error = {};
                error[name] = err.isMessage ? err.txt : err;
                this.errors = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, this.errors, error);
            }
            if (!this.errors[name]) {
                try {
                    this.sett._save();
                } catch (err) {
                    console.log('Can\'t save settings. Error: ', err);
                }
            }
        }
    }
});

/***/ }),

/***/ "matE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('md-button',{class:{
        'md-primary': true,
        'md-raised': _vm.isRaised,
        'md-dense': _vm.isDense,
        'md-icon-button': _vm.icon,
    },attrs:{"md-theme":_vm.isThInv ? _vm.th+'i' : _vm.th,"href":_vm.href,"target":_vm.href ? _vm.target : undefined,"md-ripple":_vm.isRipple,"disabled":_vm.isDisabled}},[(_vm.desc)?_c('dkbr-tooltip',{attrs:{"text":_vm.desc,"dir":_vm.tltpDir,"dt":_vm.tltpDt}}):_vm._e(),(_vm.icon)?_c('dkbr-icon',{attrs:{"th":_vm.th,"isThInv":_vm.isThInv,"name":_vm.icon,"size":_vm.iconSize,"source":_vm.iconSource}}):_vm._e(),_vm._t("default",[_c('span',[_vm._v(_vm._s(_vm.text))])])],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "njXQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dkbr-text",class:[
        'dkbr-text_align_'+_vm.align,
        'dkbr-text_display_'+_vm.display
    ]},[_vm._v(_vm._s(_vm.text))])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "oRT8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SettingsManager_vue__ = __webpack_require__("MWSf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2c3b7d5f_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_SettingsManager_vue__ = __webpack_require__("zYFb");
function injectStyle (ssrContext) {
  __webpack_require__("yh05")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SettingsManager_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2c3b7d5f_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_SettingsManager_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "pTJB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dt-footer"},[_c('h3',{staticClass:"dt-footer__text"},[_vm._v("© 2017.\n"),(_vm.isENG)?_c('span',[_vm._v("Tensor networks and deep learning for applications in data mining.")]):_vm._e(),(_vm.isRUS)?_c('span',[_vm._v("Тензорные сети и глубинное обучение для интеллектуального анализа данных.")]):_vm._e(),_c('br'),(_vm.isENG)?_c('span',[_vm._v("All rights reserved.")]):_vm._e(),(_vm.isRUS)?_c('span',[_vm._v("Все права защищены.")]):_vm._e()]),(_vm.isENG)?_c('figure',{staticClass:"dt-footer__imgs dt-footer--imgs"},[_vm._m(0),_vm._m(1)]):_vm._e(),(_vm.isRUS)?_c('figure',{staticClass:"dt-footer__imgs dt-footer--imgs"},[_vm._m(2),_vm._m(3)]):_vm._e()])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"dt-footer--imgs__img",attrs:{"href":"http://минобрнауки.рф/lang/en","target":"_blank"}},[_c('img',{attrs:{"src":__webpack_require__("Bw1y")}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"dt-footer--imgs__img",attrs:{"href":"http://www.skoltech.ru/en/","target":"_blank"}},[_c('img',{attrs:{"src":__webpack_require__("AmdL")}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"dt-footer--imgs__img",attrs:{"href":"http://минобрнауки.рф/lang/ru","target":"_blank"}},[_c('img',{attrs:{"src":__webpack_require__("B0Ka")}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"dt-footer--imgs__img",attrs:{"href":"http://www.skoltech.ru/?lang=ru","target":"_blank"}},[_c('img',{attrs:{"src":__webpack_require__("+M4T")}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "puQD":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "qbl9":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "qdhV":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "qkpW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// https://vuematerial.io/components/icon
// http://fontawesome.io/icons/

/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'dkbr-icon',
    props: {
        th: {
            name: 'th',
            type: String,
            enum: ['th1', 'th2', 'th3', 'th4', 'th5', 'th6', 'th7'],
            txtDescr: 'Color theme of the element',
            default: function _default(_) {
                return 'th1';
            }
        },
        isThInv: {
            name: 'isThInv',
            type: Boolean,
            txtDescr: 'If is true, inversed color theme will be used',
            default: function _default(_) {
                return false;
            }
        },
        name: {
            name: 'name',
            type: String,
            txtDescr: 'Icon name',
            default: function _default(_) {
                return 'menu';
            }
        },
        size: {
            name: 'size',
            type: Number,
            enum: [1, 2, 3, 4, 5],
            txtDescr: 'Icon size',
            default: function _default(_) {
                return 1;
            }
        },
        text: {
            name: 'text',
            type: String,
            txtDescr: 'Text near icon',
            default: function _default(_) {
                return '';
            }
        },
        textDir: {
            name: 'textDir',
            type: String,
            enum: ['right', 'left'],
            txtDescr: 'Text position relative to icon',
            default: function _default(_) {
                return 'right';
            }
        },
        source: {
            name: 'source',
            type: String,
            enum: ['gg', 'fa'],
            txtDescr: 'Icon source (google, font-awesome, etc.)',
            default: function _default(_) {
                return 'gg';
            }
        }
    }
});

/***/ }),

/***/ "sRjG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dkbr-figure",style:({
        width: _vm.w ? _vm.w+'px' : undefined,
        height: 'auto',
        })},[(_vm.isShow && !_vm.isMulty && _vm.src_)?_c('div',[_c('img',{staticClass:"dkbr-figure__image",style:({
                width: _vm.ws ? _vm.ws+'px' : undefined,
                height: 'auto',
                }),attrs:{"src":_vm.src_,"alt":_vm.alt}})]):_vm._e(),(_vm.isShow && _vm.isMulty)?_c('carousel-3d',{attrs:{"autoplay":_vm.isAuto,"autoplayTimeout":_vm.autoDt,"autoplayHoverPause":_vm.autoPauseH,"perspective":_vm.perspective,"display":_vm.countPage,"loop":_vm.isRepeat,"animationSpeed":_vm.animDt,"dir":_vm.dir,"width":_vm.ws,"height":_vm.hs,"count":_vm.count,"border":_vm.bd,"space":_vm.sp,"disable3d":!_vm.is3D,"startIndex":_vm.sl,"controlsWidth":_vm.wc,"controlsHeight":_vm.hc,"inverseScaling":_vm.scaling,"minSwipeDistance":_vm.swipe,"clickable":_vm.isClick}},_vm._l((_vm.srcs_),function(s,i){return _c('slide',{key:i,attrs:{"index":i}},[_c('div',{staticClass:"dkbr-figure__image-wrapper"},[_c('img',{staticClass:"dkbr-figure__image",attrs:{"src":_vm.srcParse(s)}})])])})):_vm._e(),_vm._t("default",[(_vm.txt)?_c('div',{staticClass:"dkbr-figure__text",domProps:{"innerHTML":_vm._s(_vm.txt)}}):_vm._e()])],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "sy8i":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'dkbr-link',
    props: {
        th: {
            name: 'th',
            type: String,
            enum: ['th1', 'th2', 'th3', 'th4', 'th5', 'th6', 'th7'],
            txtDescr: 'Color theme of the element',
            default: function _default(_) {
                return 'th1';
            }
        },
        isThInv: {
            name: 'isThInv',
            type: Boolean,
            txtDescr: 'If is true, inversed color theme will be used',
            default: function _default(_) {
                return false;
            }
        },
        name: {
            name: 'name',
            type: String,
            txtDescr: 'Icon name',
            default: function _default(_) {
                return 'menu';
            }
        },
        size: {
            name: 'size',
            type: Number,
            enum: [1, 2, 3, 4, 5],
            txtDescr: 'Icon size',
            default: function _default(_) {
                return 1;
            }
        },
        text: {
            name: 'text',
            type: String,
            txtDescr: 'Text near icon',
            default: function _default(_) {
                return '';
            }
        },
        textDir: {
            name: 'textDir',
            type: String,
            enum: ['right', 'left'],
            txtDescr: 'Text position relative to icon',
            default: function _default(_) {
                return 'right';
            }
        },
        source: {
            name: 'source',
            type: String,
            enum: ['gg', 'fa'],
            txtDescr: 'Icon source (google, font-awesome, etc.)',
            default: function _default(_) {
                return 'gg';
            }
        }
    }
});

/***/ }),

/***/ "tsh4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__("Zrlr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__("wxAW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);


function formatDate(date) {
  var addZero = function addZero(i) {
    return i < 10 ? '0' + i : i;
  };
  var hour = addZero(date.getHours());
  var mins = addZero(date.getMinutes());
  var secs = addZero(date.getSeconds());
  var y = date.getFullYear();
  var m = addZero(date.getMonth() + 1);
  var d = addZero(date.getDate());
  return y + '-' + m + '-' + d + ' ' + hour + ':' + mins + ':' + secs;
}
function fill() {
  var symb = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : ' ';
  var n = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;

  if (n < 1) return '';
  return symb.repeat(n);
}

var Message = function () {
  function Message() {
    var mess = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Message);

    this.app = mess.app || '';
    this.name = mess.name || 'fatal';
    this.txt = mess.txt || '';
    this.cl = mess.cl || '';
    this.func = mess.func || '';
    this.obj = mess.obj || null;
    if (mess.obj && mess.obj.str) this.obj = mess.obj.str();
    if (mess.obj && !mess.obj.str) this.obj = mess.obj.toString();
    this.date = formatDate(new Date());
    this.isMessage = true;
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(Message, [{
    key: 'str',
    value: function str() {
      var sp = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : ' ';
      var br = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '\n';

      var res = '>>>>> [' + this.date + '] ' + this.name.toUpperCase();
      res += fill(sp, 7 - this.name.length);
      if (this.app) res += ' | ' + this.app;
      if (this.cl) res += ' | ' + this.cl;
      if (this.func) res += ' | ' + this.func;
      if (this.txt) res += br + fill(sp, 4) + ('> ' + this.txt);
      if (this.obj) res += br + fill(sp, 3) + '>> DETAILS:' + br + this.obj + br + '-----';
      return res;
    }
  }, {
    key: 'strCompact',
    value: function strCompact() {
      return '[' + this.date + '] ' + this.txt;
    }
  }, {
    key: 'htm',
    value: function htm() {
      return this.str('&nbsp;', '<br>');
    }
  }, {
    key: 'json',
    value: function json() {
      return { app: this.app, name: this.name, txt: this.txt, cl: this.cl, func: this.func, obj: this.obj, isMessage: true };
    }
  }]);

  return Message;
}();

/* harmony default export */ __webpack_exports__["a"] = (Message);

/***/ }),

/***/ "ttFj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{staticClass:"dt"},[_c('dt-header',{staticClass:"dt__header"}),_c('dt-nav',{staticClass:"dt__nav",attrs:{"pages":_vm.pages}}),_c('div',{staticClass:"dt__content"},[_c('transition',{attrs:{"name":'dt__content_'+_vm.routeDir,"mode":"out-in"}},[_c('keep-alive',[_c('router-view')],1)],1)],1),_c('dt-footer',{staticClass:"dt__footer"})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "uQpO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Icon_vue__ = __webpack_require__("qkpW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3c8f8f5e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_Icon_vue__ = __webpack_require__("WWVF");
function injectStyle (ssrContext) {
  __webpack_require__("AfmF")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Icon_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3c8f8f5e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_Icon_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "uslO":
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": "3CJN",
	"./af.js": "3CJN",
	"./ar": "3MVc",
	"./ar-dz": "tkWw",
	"./ar-dz.js": "tkWw",
	"./ar-kw": "j8cJ",
	"./ar-kw.js": "j8cJ",
	"./ar-ly": "wPpW",
	"./ar-ly.js": "wPpW",
	"./ar-ma": "dURR",
	"./ar-ma.js": "dURR",
	"./ar-sa": "7OnE",
	"./ar-sa.js": "7OnE",
	"./ar-tn": "BEem",
	"./ar-tn.js": "BEem",
	"./ar.js": "3MVc",
	"./az": "eHwN",
	"./az.js": "eHwN",
	"./be": "3hfc",
	"./be.js": "3hfc",
	"./bg": "lOED",
	"./bg.js": "lOED",
	"./bm": "hng5",
	"./bm.js": "hng5",
	"./bn": "aM0x",
	"./bn.js": "aM0x",
	"./bo": "w2Hs",
	"./bo.js": "w2Hs",
	"./br": "OSsP",
	"./br.js": "OSsP",
	"./bs": "aqvp",
	"./bs.js": "aqvp",
	"./ca": "wIgY",
	"./ca.js": "wIgY",
	"./cs": "ssxj",
	"./cs.js": "ssxj",
	"./cv": "N3vo",
	"./cv.js": "N3vo",
	"./cy": "ZFGz",
	"./cy.js": "ZFGz",
	"./da": "YBA/",
	"./da.js": "YBA/",
	"./de": "DOkx",
	"./de-at": "8v14",
	"./de-at.js": "8v14",
	"./de-ch": "Frex",
	"./de-ch.js": "Frex",
	"./de.js": "DOkx",
	"./dv": "rIuo",
	"./dv.js": "rIuo",
	"./el": "CFqe",
	"./el.js": "CFqe",
	"./en-au": "Sjoy",
	"./en-au.js": "Sjoy",
	"./en-ca": "Tqun",
	"./en-ca.js": "Tqun",
	"./en-gb": "hPuz",
	"./en-gb.js": "hPuz",
	"./en-ie": "ALEw",
	"./en-ie.js": "ALEw",
	"./en-nz": "dyB6",
	"./en-nz.js": "dyB6",
	"./eo": "Nd3h",
	"./eo.js": "Nd3h",
	"./es": "LT9G",
	"./es-do": "7MHZ",
	"./es-do.js": "7MHZ",
	"./es-us": "INcR",
	"./es-us.js": "INcR",
	"./es.js": "LT9G",
	"./et": "XlWM",
	"./et.js": "XlWM",
	"./eu": "sqLM",
	"./eu.js": "sqLM",
	"./fa": "2pmY",
	"./fa.js": "2pmY",
	"./fi": "nS2h",
	"./fi.js": "nS2h",
	"./fo": "OVPi",
	"./fo.js": "OVPi",
	"./fr": "tzHd",
	"./fr-ca": "bXQP",
	"./fr-ca.js": "bXQP",
	"./fr-ch": "VK9h",
	"./fr-ch.js": "VK9h",
	"./fr.js": "tzHd",
	"./fy": "g7KF",
	"./fy.js": "g7KF",
	"./gd": "nLOz",
	"./gd.js": "nLOz",
	"./gl": "FuaP",
	"./gl.js": "FuaP",
	"./gom-latn": "+27R",
	"./gom-latn.js": "+27R",
	"./gu": "rtsW",
	"./gu.js": "rtsW",
	"./he": "Nzt2",
	"./he.js": "Nzt2",
	"./hi": "ETHv",
	"./hi.js": "ETHv",
	"./hr": "V4qH",
	"./hr.js": "V4qH",
	"./hu": "xne+",
	"./hu.js": "xne+",
	"./hy-am": "GrS7",
	"./hy-am.js": "GrS7",
	"./id": "yRTJ",
	"./id.js": "yRTJ",
	"./is": "upln",
	"./is.js": "upln",
	"./it": "FKXc",
	"./it.js": "FKXc",
	"./ja": "ORgI",
	"./ja.js": "ORgI",
	"./jv": "JwiF",
	"./jv.js": "JwiF",
	"./ka": "RnJI",
	"./ka.js": "RnJI",
	"./kk": "j+vx",
	"./kk.js": "j+vx",
	"./km": "5j66",
	"./km.js": "5j66",
	"./kn": "gEQe",
	"./kn.js": "gEQe",
	"./ko": "eBB/",
	"./ko.js": "eBB/",
	"./ky": "6cf8",
	"./ky.js": "6cf8",
	"./lb": "z3hR",
	"./lb.js": "z3hR",
	"./lo": "nE8X",
	"./lo.js": "nE8X",
	"./lt": "/6P1",
	"./lt.js": "/6P1",
	"./lv": "jxEH",
	"./lv.js": "jxEH",
	"./me": "svD2",
	"./me.js": "svD2",
	"./mi": "gEU3",
	"./mi.js": "gEU3",
	"./mk": "Ab7C",
	"./mk.js": "Ab7C",
	"./ml": "oo1B",
	"./ml.js": "oo1B",
	"./mr": "5vPg",
	"./mr.js": "5vPg",
	"./ms": "ooba",
	"./ms-my": "G++c",
	"./ms-my.js": "G++c",
	"./ms.js": "ooba",
	"./my": "F+2e",
	"./my.js": "F+2e",
	"./nb": "FlzV",
	"./nb.js": "FlzV",
	"./ne": "/mhn",
	"./ne.js": "/mhn",
	"./nl": "3K28",
	"./nl-be": "Bp2f",
	"./nl-be.js": "Bp2f",
	"./nl.js": "3K28",
	"./nn": "C7av",
	"./nn.js": "C7av",
	"./pa-in": "pfs9",
	"./pa-in.js": "pfs9",
	"./pl": "7LV+",
	"./pl.js": "7LV+",
	"./pt": "ZoSI",
	"./pt-br": "AoDM",
	"./pt-br.js": "AoDM",
	"./pt.js": "ZoSI",
	"./ro": "wT5f",
	"./ro.js": "wT5f",
	"./ru": "ulq9",
	"./ru.js": "ulq9",
	"./sd": "fW1y",
	"./sd.js": "fW1y",
	"./se": "5Omq",
	"./se.js": "5Omq",
	"./si": "Lgqo",
	"./si.js": "Lgqo",
	"./sk": "OUMt",
	"./sk.js": "OUMt",
	"./sl": "2s1U",
	"./sl.js": "2s1U",
	"./sq": "V0td",
	"./sq.js": "V0td",
	"./sr": "f4W3",
	"./sr-cyrl": "c1x4",
	"./sr-cyrl.js": "c1x4",
	"./sr.js": "f4W3",
	"./ss": "7Q8x",
	"./ss.js": "7Q8x",
	"./sv": "Fpqq",
	"./sv.js": "Fpqq",
	"./sw": "DSXN",
	"./sw.js": "DSXN",
	"./ta": "+7/x",
	"./ta.js": "+7/x",
	"./te": "Nlnz",
	"./te.js": "Nlnz",
	"./tet": "gUgh",
	"./tet.js": "gUgh",
	"./th": "XzD+",
	"./th.js": "XzD+",
	"./tl-ph": "3LKG",
	"./tl-ph.js": "3LKG",
	"./tlh": "m7yE",
	"./tlh.js": "m7yE",
	"./tr": "k+5o",
	"./tr.js": "k+5o",
	"./tzl": "iNtv",
	"./tzl.js": "iNtv",
	"./tzm": "FRPF",
	"./tzm-latn": "krPU",
	"./tzm-latn.js": "krPU",
	"./tzm.js": "FRPF",
	"./uk": "ntHu",
	"./uk.js": "ntHu",
	"./ur": "uSe8",
	"./ur.js": "uSe8",
	"./uz": "XU1s",
	"./uz-latn": "/bsm",
	"./uz-latn.js": "/bsm",
	"./uz.js": "XU1s",
	"./vi": "0X8Q",
	"./vi.js": "0X8Q",
	"./x-pseudo": "e/KL",
	"./x-pseudo.js": "e/KL",
	"./yo": "YXlc",
	"./yo.js": "YXlc",
	"./zh-cn": "Vz2w",
	"./zh-cn.js": "Vz2w",
	"./zh-hk": "ZUyn",
	"./zh-hk.js": "ZUyn",
	"./zh-tw": "BbgG",
	"./zh-tw.js": "BbgG"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "uslO";

/***/ }),

/***/ "v/J1":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "vocj":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "w1YS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
    BIT: {
        desc: 'Битовое число, содержащее заданное количество битов',
        sub1: 1
    },
    BOOLEAN: {
        syn: ['BOOL'],
        desc: 'Boolean field',
        enum: ['FALSE', 'TRUE']
    },
    TINYINT: {
        desc: 'Целое число',
        sub1: 10,
        min: '-128',
        max: '127',
        maxp: '255',
        unsigned: true
    },
    SMALLINT: {
        desc: 'Целое число',
        sub1: 10,
        min: '-32 768',
        max: '32 767',
        maxp: '65 535',
        unsigned: true
    },
    MEDIUMINT: {
        desc: 'Целое число',
        sub1: 10,
        min: '-8 388 608',
        max: '8 388 607',
        maxp: '16 777 215',
        unsigned: true
    },
    INT: {
        syn: ['INTEGER'],
        desc: 'Целое число',
        sub1: 10,
        min: '-2 147 483 648',
        max: '2 147 483 647',
        maxp: '4 294 967 295',
        unsigned: true
    },
    BIGINT: {
        desc: 'Целое число',
        sub1: 10,
        min: '-9 223 372 036 854 775 808',
        max: '9 223 372 036 854 775 807',
        maxp: '18 446 744 073 709 551 615',
        unsigned: true
    },
    FLOAT: {
        desc: 'Вещественное число с точностью около 7 значащих цифр',
        sub1: 10,
        min: '-3,402823466**38',
        max: '3,402823466**38',
        unsigned: true
    },
    DOUBLE: {
        syn: ['DOUBLE PRECISION', 'REAL'],
        desc: 'Вещественное число с точностью около 15 значащих цифр',
        sub1: 10,
        min: '-1,7976931348623157**308',
        max: '1,7976931348623157**308',
        unsigned: true
    },
    DECIMAL: {
        syn: ['DEC', 'NUMERIC', 'FIXED'],
        desc: 'Точное число с фиксированной точкой (до 65.30 цифр).',
        sub1: 10,
        sub2: 0,
        unsigned: true
    },
    YEAR: {
        sub1: 4,
        min: '1901',
        max: '2155',
        form: 'YYYY'
    },
    DATE: {
        min: '0000-01-01',
        max: '9999-12-31',
        form: 'YYYY-MM-DD'
    },
    TIME: {
        min: '-838:59:59',
        max: '838:59:59',
        form: 'HH:MM:SS'
    },
    DATETIME: {
        min: '0000-01-01 00:00:00',
        max: '9999-12-31 23:59:59',
        form: 'YYYY-MM-DD HH:MM:SS'
    },
    TIMESTAMP: {
        desc: 'Отметка времени DATETIME. При добавлении или изменении строки таблицы в столбце с типом TIMESTAMP автоматически устанавливается дата и время выполнения операции (если значение этого столбца не указано явно или указано неопределенное значение). Если нужно, чтобы отметка времени проставлялась только при добавлении строки, после слова TIMESTAMP добавим свойство DEFAULT CURRENT_TIMESTAMP. Если в таблице есть несколько столбцов с типом TIMESTAMP, отметка времени автоматически проставляется только в первом из них. Если необходимо также вносить отметку времени в какой-либо из последующих столбцов с типом TIMESTAMP, то при добавлении/изменении строки укажем для этого столбца значение NULL, которое будет автоматически заменено текущей датой.',
        min: '1970-01-01 00:00:00',
        max: '2038 year',
        form: 'YYYY-MM-DD HH:MM:SS'
    },
    CHAR: {
        desc: 'Символьная строка фиксированной длины',
        sub1: 1
    },
    VARCHAR: {
        desc: 'Символьная строка переменной длины, содержащая не более указанного количества символов',
        sub1: 1
    },
    BINARY: {
        desc: 'Байтовая (бинарная) строка фиксированной длины',
        sub1: 1
    },
    VARBINARY: {
        desc: 'Байтовая (бинарная) строка переменной длины',
        sub1: 1
    },
    BLOB: {
        desc: 'Байтовая (бинарная) строка переменной длины. Если количество байтов указано, то создается столбец с типом данных TINYBLOB, BLOB, MEDIUMBLOB или LONGBLOB: выбирается тип данных с наименьшим размером, достаточным для хранения этого количества байтов',
        sub1: 65535
    },
    TINYBLOB: {
        desc: 'Байтовая (бинарная) строка переменной длины',
        max: '255'
    },
    MEDIUMBLOB: {
        desc: 'Байтовая (бинарная) строка переменной длины',
        max: '16 777 215'
    },
    LONGBLOB: {
        desc: 'Байтовая (бинарная) строка переменной длины',
        max: '4 294 967 295' // 4 Gb
    },
    TEXT: {
        desc: 'Символьная строка переменной длины. Если количество символов указано, то создается столбец с типом данных TINYTEXT, TEXT, MEDIUMTEXT или LONGTEXT: выбирается тип данных с наименьшим размером, достаточным для хранения этого количества символов',
        sub1: 65535
    },
    TINYTEXT: {
        desc: 'Символьная строка переменной длины',
        max: '255'
    },
    MEDIUMTEXT: {
        desc: 'Символьная строка переменной длины',
        max: '16 777 215'
    },
    LONGTEXT: {
        desc: 'Символьная строка переменной длины',
        max: '4 294 967 295' // 4 Gb
    },
    ENUM: {
        sub1: '',
        sub2: '',
        desc: 'Строка, содержащая ровно один элемент из заданного списка или пустую строку',
        max: '65 535' // elements in list
    },
    SET: {
        desc: 'Строка, содержащая любой набор элементов из заданного списка или пустую строку или NULL',
        max: '64' // elements in list
    },
    SERIAL: {
        syn: ['BIGINT UNSIGNED NOT NULL AUTO_INCREMENT UNIQUE']
    }
});

/***/ }),

/***/ "xjJ1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


__webpack_require__.e/* import() */(6).then(__webpack_require__.bind(null, "7zck"));

/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'dkbr',
    created: function created() {
        try {
            this.ST._load();
            this.CS.res('Settings are loaded', this.CLASS, 'created');
        } catch (err) {
            this.CS.err('Can\'t load settings', this.CLASS, 'created', err);
        }
    },
    beforeDestroy: function beforeDestroy() {
        try {
            this.ST._save();
            this.CS.res('Settings are saved', this.CLASS, 'beforeDestroy');
        } catch (err) {
            this.CS.err('Can\'t save settings', this.CLASS, 'beforeDestroy', err);
        }
    }
});

/***/ }),

/***/ "yYAx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Frame_vue__ = __webpack_require__("6tGn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bf2dd830_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_Frame_vue__ = __webpack_require__("cgvj");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Frame_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bf2dd830_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_Frame_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ybxW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'dkbr-input',
    txtDescr: 'Input. Emit the "edited" event on change with the new value. Property "value" should be updated manually outside. If type of the field is Boolean and it is not Enabled/Editable, then checkbox is used, the switch is used otherwise (use "isCheckBox" and "isSwitch" props to change it)',
    props: {
        th: {
            name: 'th',
            type: String,
            enum: ['th1', 'th2', 'th3', 'th4', 'th5', 'th6', 'th7'],
            txtDescr: 'Color theme of the element',
            default: function _default(_) {
                return 'th1';
            }
        },
        isThInv: {
            name: 'isThInv',
            type: Boolean,
            txtDescr: 'If is true, inversed color theme will be used',
            default: function _default(_) {
                return false;
            }
        },
        value: {
            name: 'value',
            txtDescr: 'Initial value for input',
            default: function _default(_) {
                return undefined;
            }
        },
        name: {
            name: 'name',
            type: String,
            txtDescr: 'Title for input field',
            default: function _default(_) {
                return 'Option';
            }
        },
        type: {
            name: 'type',
            type: String,
            enum: ['boolean', 'number', 'string', 'array'],
            txtDescr: 'Type of the value (\';\' delimiter should be used for array type without enum)',
            default: function _default(_) {
                return 'string';
            }
        },
        enum: {
            name: 'enum',
            type: Array,
            txtDescr: 'A list of possible options for the value',
            txtEnable: 'Is not enabled for boolean',
            default: function _default(_) {
                return undefined;
            },
            enabled: function enabled(v, sett) {
                return sett.type != 'boolean';
            }
        },
        txtDescr: {
            name: 'txtDescr',
            type: String,
            txtDescr: 'Description of the value',
            default: function _default(_) {
                return '';
            }
        },
        txtEditable: {
            name: 'txtEditable',
            type: String,
            txtDescr: 'Explanation why value is not editable',
            default: function _default(_) {
                return '';
            }
        },
        txtEnable: {
            name: 'txtEnable',
            type: String,
            txtDescr: 'Explanation why value is not enabled',
            default: function _default(_) {
                return '';
            }
        },
        txtError: {
            name: 'txtError',
            type: String,
            txtDescr: 'String representation of an error for the current value',
            default: function _default(_) {
                return '';
            }
        },
        lengthMax: {
            name: 'lengthMax',
            type: Number,
            txtDescr: 'Maximum length of the input text',
            txtEnable: 'Is not enabled for boolean and array or if enum is set',
            txtError: 'It should be non negative number',
            enabled: function enabled(v, sett) {
                return (!sett.enum || !sett.enum.length) && sett.type != 'boolean' && sett.type != 'array';
            },
            validator: function validator(v, sett) {
                return v >= 0;
            },
            default: function _default(_) {
                return 0;
            }
        },
        lengthShortMax: {
            name: 'lengthShortMax',
            type: Number,
            txtDescr: 'If text is longer, input will be shown as textarea',
            txtEnable: 'Is not enabled for boolean and array or if enum is set',
            txtError: 'It should be non negative number',
            enabled: function enabled(v, sett) {
                return (!sett.enum || !sett.enum.length) && sett.type != 'boolean' && sett.type != 'array';
            },
            validator: function validator(v, sett) {
                return v >= 0;
            },
            default: function _default(_) {
                return 50;
            }
        },
        tooltipDir: {
            name: 'tooltipDir',
            type: String,
            enum: ['top', 'right', 'bottom', 'left', 'none'],
            txtDescr: 'Direction of the tooltip',
            default: function _default(_) {
                return 'right';
            }
        },
        isRequired: {
            name: 'isRequired',
            type: Boolean,
            txtDescr: 'If true, input will be shown as \'required\'',
            default: function _default(_) {
                return false;
            }
        },
        isEditable: {
            name: 'isEditable',
            type: Boolean,
            txtDescr: 'If false, input will be read only',
            default: function _default(_) {
                return true;
            }
        },
        isEnabled: {
            name: 'isEnabled',
            type: Boolean,
            txtDescr: 'If false, input will be shown in deactivated mode',
            default: function _default(_) {
                return true;
            }
        },
        isPassword: {
            name: 'isPassword',
            type: Boolean,
            txtDescr: 'If true, input will be shown as a password (stars)',
            txtEnable: 'Is not enabled for boolean type or if enum is set',
            enabled: function enabled(v, sett) {
                return (!sett.enum || !sett.enum.length) && sett.type != 'boolean' && sett.type != 'array';
            },
            default: function _default(_) {
                return false;
            }
        },
        isCheckBox: {
            name: 'isCheckBox',
            type: Boolean,
            txtDescr: 'If is true, then checkbox will be always used for Boolean',
            txtEnable: 'Is may be applied only for Boolean',
            enabled: function enabled(v, sett) {
                return sett.type == 'boolean';
            },
            default: function _default(_) {
                return false;
            }
        },
        isSwitch: {
            name: 'isSwitch',
            type: Boolean,
            txtDescr: 'If is true, then switch will be always used for Boolean',
            txtEnable: 'Is may be applied only for Boolean and if not isCheckBox',
            enabled: function enabled(v, sett) {
                return sett.type == 'boolean' && !sett.isCheckBox;
            },
            default: function _default(_) {
                return false;
            }
        }
    },
    data: function data() {
        return {
            value_: this.valueParse(this.value)
        };
    },

    computed: {
        length: function length() {
            return this.value_.toString().length;
        },
        displayIn: function displayIn() {
            if (this.type == 'boolean' && this.isCheckBox) return 'checkbox';
            if (this.type == 'boolean' && this.isSwitch) return 'switch';
            if (this.type == 'boolean' && !this.isEditable) return 'checkbox';
            if (this.type == 'boolean' && this.isEditable) return 'switch';
            if (this.enum && this.enum.length) return 'select';
            if (this.length <= this.lengthShortMax) return 'input';
            if (this.isPassword) return 'input';
            if (this.type == 'number') return 'input';
            return 'textarea';
        },
        descrFull: function descrFull() {
            var s = this.txtDescr;
            if (!this.isEditable && this.txtEditable) s += '. ' + this.txtEditable;
            if (!this.isEnabled && this.txtEnable) s += '. ' + this.txtEnable;
            return s;
        }
    },
    watch: {
        value: function value(valueNew) {
            this.value_ = this.valueParse(valueNew);
        },
        value_: function value_(valueNew) {
            // is used only due to bug in 'select' component
            console.log('value_', this.value_, this.enum, this.valueParse(this.value_));
            if (this.displayIn == 'select') this.edited();
        }
    },
    methods: {
        valueParse: function valueParse(value) {
            if (this.type == 'boolean') return Boolean(value);
            if (this.type == 'number') return Number(value);
            if (this.type == 'string') return value ? String(value) : '';
            if (this.type == 'array' && this.enum) {
                if (value === undefined) return [];
                if (Array.isArray(value)) return value;else return value.split(';');
            }
            if (this.type == 'array' && !this.enum) {
                if (value === undefined) return '';
                if (Array.isArray(value)) return value.join(';');else return value ? value.split(';') : [];
            }
            throw 'Incorrect value type ("type" prop)';
        },
        edited: function edited(v) {
            console.log('edited', this.value_, this.enum, this.valueParse(this.value_), v);
            this.$emit('edited', this.valueParse(this.value_));
        }
    }
});

/***/ }),

/***/ "ycBI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__settings_Settings_js__ = __webpack_require__("V+2q");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__frame_vue_Frame__ = __webpack_require__("yYAx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__settings_vue_SettingsManager__ = __webpack_require__("oRT8");







/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'dkbr-demo-builder',
    props: {
        Elem: {
            type: Object,
            required: true
        }
    },
    data: function data() {
        return {
            settFrame: new __WEBPACK_IMPORTED_MODULE_0__settings_Settings_js__["a" /* default */](__WEBPACK_IMPORTED_MODULE_1__frame_vue_Frame__["a" /* default */].props, {}, 'Demo-' + this.Elem.name, __WEBPACK_IMPORTED_MODULE_1__frame_vue_Frame__["a" /* default */].name),
            sett: new __WEBPACK_IMPORTED_MODULE_0__settings_Settings_js__["a" /* default */](this.Elem.props, {}, 'Demo-' + this.Elem.name, this.Elem.name)
        };
    },
    created: function created() {
        try {
            this.settFrame._load();
            this.sett._load();
        } catch (err) {
            console.log('Can\'t load settings. Error: ', err);
        }
    },
    render: function render(h) {
        return h('div', { 'class': ['demo-builder'] }, [h('div', { 'class': ['demo-builder__settings'] }, [h(__WEBPACK_IMPORTED_MODULE_2__settings_vue_SettingsManager__["a" /* default */], { props: { setts: [this.sett, this.settFrame] } })]), h('div', { 'class': ['demo-builder__frame'] }, [h(__WEBPACK_IMPORTED_MODULE_1__frame_vue_Frame__["a" /* default */], { props: this.settFrame }, [h(this.Elem, { props: this.sett })])])]);
    }
});

/***/ }),

/***/ "ycBr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = animation;
/* Function animation:
 *   call given function for every animation frame while it returns true.
**/
function animation(func) {
  var animate = function animate() {
    if (func()) window.requestAnimationFrame(animate);
  };
  window.requestAnimationFrame(animate);
}

/***/ }),

/***/ "yh05":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "zYFb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"settings-manager"},[_c('md-list',{staticClass:"settings-manager__content"},_vm._l((_vm.setts),function(sett){return _c('md-list-item',{key:sett.NAME,staticClass:"settings-manager__item",attrs:{"md-expand":true}},[_c('md-icon',[_vm._v("whatshot")]),_c('span',{staticClass:"md-title"},[_vm._v(_vm._s(sett.TITLE))]),_c('v-settings',{staticClass:"md-dense",attrs:{"slot":"md-expand","sett":sett},slot:"md-expand"})],1)}))],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "zqF6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Settings_vue__ = __webpack_require__("mQWK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_37ca1e1e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_Settings_vue__ = __webpack_require__("1yAi");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Settings_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_37ca1e1e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_Settings_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ })

},["kmMG"]);


// WEBPACK FOOTER //
// static/js/app.fc070d6bddf1e258d9fe.js